export const FieldEnum = {
  Username: 'username',
  Password: 'password',
  ConfirmPassword: 'confirmPassword',
  DistrictId: 'districtId',
  Description: 'description',
  Id: 'id',
  IdSeed: 'idSeed',
  FirstName: 'firstName',
  LastName: 'lastName',
  RoleId: 'roleId',
  IsActive: 'isActive',
  Email: 'email',
  FiscalYear: 'fiscalyear',
  SiteGroupId: 'sitegroupId',
  PrimarySiteId: 'primarysiteId',
  SiteType: 'siteType',
  ManagersEmailId: 'managersemailId',
  IsLicensed: 'isLicensed',
  Contact: 'contact',
  ShipAddress1: 'shipAddress1',
  ShipAddress2: 'shipAddress2',
  ShipAddress3: 'shipAddress3',
  ShipZipCode: 'shipZipCode',
  ShipState: 'shipState',
  ShipCity: 'shipCity',
  BillAddress1: 'billAddress1',
  BillAddress2: 'billAddress2',
  BillAddress3: 'billAddress3',
  BillAttention: 'billAttention',
  ShipAttention: 'shipAttention',
  BillZipCode: 'billZipCode',
  BillState: 'billState',
  BillCity: 'billCity',
  Free: 'free',
  Reduced: 'reduced',
  Paid: 'paid',
  Membership: 'membership',
  AlternateProvisionId: 'alternateProvisionId',
  ServingSite: 'servingSite',
  AttendanceFactor: 'attendanceFactor',
  ChargeFlag: 'chargeFlag',
  SevereNeed: 'severeNeed',
  AreaEligible: 'areaEligible',
  BreakfastId: 'breakfastId',
  LunchId: 'lunchId',
  SupperId: 'supperId',
  AdditionalCredit: 'additionalCredit',
  MinimumPayment: 'minimumPayment',
  AlaCarteExpense: 'alaCarteExpense',
  AlaCarteAmount: 'AlaCarteAmount',
  AlaCarteExpFrequency: 'AlaCarteExpFrequency',
  StudentImportFailReason: 'studentImportFailReason',
  ToDate: 'toDate',
  FromDate: 'fromDate',
  AllDates: 'allDates',
  SortBy: 'sortBy',
  MBEDate: 'mbeDate',
  SiteId: 'siteId',
  ServingNum: 'servingNum',
  BirthDate: 'birthDate',
  Teacher: 'teacher',
  Grade: 'grade',
  LanguageId: 'languageId',
  BillingAcc: 'billingAcc',
  StateNum: 'stateNum',
  StatusCurrent: 'statusCurrent',
  StatusPrevious: 'statusPrevious',
  StatusFuture: 'statusFuture',
  Payments: 'payments',
  Balance: 'balance',
  Purchases: 'purchases',
  Message: 'message',
  NonLea: 'nonLea',
  ParentFirstName: 'parentFirstName',
  ParentLastName: 'parentLastName',
  ContactNumber: 'contactNumber',
  StudentInfoImage: 'studentInfoImage',
  StudentInfoImagePreview: 'studentInfoImagePreview',
  Clone_TotalPay: 'Clone_TotalPay',
  Clone_TotalPurchase: 'Clone_TotalPurchase',
  TotalPay: 'TotalPay',
  TotalPurchase: 'TotalPurchase',
  UserRoleAccessRole: 'roleId',
  UserRoleAccessInfoValues: 'accessInfoValues',
  Phone: 'phone',
  Route: 'route',
  OrderPreferenceId: 'orderPreferenceId',
  VendorId: 'vendorId ',
  ApplyHandlingFee: 'applyHandlingFee',
  StapleDayOfWeekId: 'stapleDayOfWeekId',
  StapleRoute: 'stapleRoute',
  StapleStorageLocationId: 'StapleStorageLocationId',
  IsBillAddSameAsShipAdd: 'isBillAddSameAsShipAdd',
  WareHousesAndKitchens: 'WarehousesAndKitchens',
  Allowed: 'Allowed',
  IsReadOnly: 'IsReadOnly',
  AccessibleFunctions: 'AccessibleFunctions',
  GroupName: 'GroupName',
  SubGroupName: 'SubGroupName',
  FunctionName: 'FunctionName',
  IsPageAccessible: 'IsPageAccessible',
  FamilyIdentifier: 'FamilyIdentifier',
  HomeRoom: 'HomeRoom',
  CEP_Transfer: 'CEP_Transfer',
};

export const RegisterFieldEnum = {
  Username: 'username',
  NewUsername: 'newUsername',
  OldPassword: 'oldPassword',
  NewPassword: 'newPassword',
  ConfirmPassword: 'confirmPassword',
  Email: 'email',
  DistrictId: 'districtId',
  LicenseFile: 'licenseFile',
  FiscalYear: 'fiscalYear',
};

export const FileFieldEnum = {
  Id: 'id',
  FileFormatId: 'fileFormatId',
  FileSeparatorRadio: 'fileSeparatorRadio',
  HeaderRowRadio: 'headerRowRadio',
  WithdrawNotInFileRowRadio: 'withdrawNotInFileRowRadio',
  FileName: 'fileName',
  EnrolledValue: 'enrolledValue',
  WithdrawnValue: 'withdrawnValue',
  MappedValue: 'mappedValue',
  SourceValue: 'sourceValue',
  MealStatusRadio: 'mealStatusRadio',
  UseMappedValue: 'useMappedValue',
  MealStatusDropDown: 'mealStatusDropDown',
  FileEncoding: 'fileEncoding',
};

export const ImportScheduleEnum = {
  Hour: 'hour',
  Minute: 'minute',
  AMorPM: 'AMorPM',
  DaysOfTheWeek: 'daysOfTheWeek',
};

export const ReportFieldEnum = {
  Site: 'site',
  Teacher: 'teacher',
  Grade: 'grade',
  Balance: 'balance',
  BarCodes: 'barCodes',
  Allergen: 'allergen',
  DetailType: 'detailType',
  FromDate: 'fromDate',
  ToDate: 'toDate',
  Item: 'item',
  Status: 'status',
  User: 'user',
  Breakfast: 'breakfast',
  Lunch: 'lunch',
  Supper: 'supper',
  Other: 'other',
  ManualAdjustments: 'manualAdjustments',
  ZeroBalanceAdjustment: 'zeroBalanceAdjustment',
  All: 'all',
  AdditionalFilters: 'additionalFilters',
  SortBy: 'sortBy',
  GroupBy: 'groupBy',
  UseServingNumber: 'useServingNumber',
  ReportFormat: 'ReportFormat',
  IncludeNonLeaStudents: 'IncludeNonLeaStudents',
};

export const ControlInfoEnum = {
  DistrictCode: 'districtCode',
  DistrictName: 'districtName',
  Address1: 'address1',
  Address2: 'address2',
  ZipCode: 'zipCode',
  State: 'state',
  City: 'city',
  FiscalYear: 'fiscalyear',
  DirectorTitle: 'directorTitle',
  DirectorName: 'directorName',
  DirectorAddress1: 'directorAddress1',
  DirectorAddress2: 'directorAddress2',
  DirectorCity: 'directorCity',
  DirectorState: 'directorState',
  DirectorZipCode: 'directorZipCode',
  DirectorPhone: 'directorPhone',
  DirectorEmail: 'directorEmail',
  HearingTitle: 'hearingTitle',
  HearingName: 'hearingName',
  HearingAddress1: 'hearingAddress1',
  HearingAddress2: 'hearingAddress2',
  HearingCity: 'hearingCity',
  HearingState: 'hearingState',
  HearingZipCode: 'hearingZipCode',
  HearingPhone: 'hearingPhone',
  HearingEmail: 'hearingEmail',
  ServingNum: 'servingNum',
  StartsWith: 'startsWith',
  AttendanceFactor: 'attendanceFactor',
  Allergens: 'allergens',
  HHName: 'hhName',
  HHSsn: 'hhSsn',
  CaseNumber: 'caseNumber',
  StudentSsn: 'studentSsn',
  SpecialMessage: 'specialMessage',
  Category1: 'category1',
  Category2: 'category2',
  Category3: 'category3',
  Category4: 'category4',
  Category5: 'category5',
  Category6: 'category6',
  Category7: 'category7',
  Category8: 'category8',
  Category9: 'category9',
  TimeZone: 'timeZone',
  ProvisionType: 'provisionType',
  Status: 'Status',
  Enabled: 'Enabled',
  InUseAllTime: 'InUseAllTime',
  InUseThisYear: 'InUseThisYear',
  Description: 'Description',
  IsSNAPEquivalent: 'IsSNAPEquivalent',
  IsDCOnly: 'IsDCOnly',
  RequireSecondReview: 'requireSecondReview',
  RequireSecondReviewCompleteToPrint: 'requireSecondReviewCompleteToPrint',
  VerificationConfigurationType: 'VerificationType',
  CountApplicationAsOf: 'VerificationAsOfDate',
  CountStudentAsOf: 'VerificationAsOfDate_Student',
  ErrorProneApplicationPercentage: 'B_AppPer',
  ErrorProneLimit: 'B_ErrorProneLimit',
  RandomApplicationPercentage: 'AR_AppPer',
  Alt2ApplicationPercentage: 'AF_AppPer',
  Alt2Limit: 'AF_ErrorProneLimit',
  Alt2CaseNumberPercentage: 'AF_CaseNumPer',
  NextPONumber: 'NextPONumber',
  POStatement: 'POStatement',
  Signature_FinanceOfficer: 'Signature_FinanceOfficer',
  EnableLPP: 'EnableLPP',
  TaxRate: 'TaxRate',
  ApplyCycleBehavior_MNU: 'ApplyCycleBehavior_MNU',
  UpdateINV_MNU: 'UpdateINV_MNU',
  ShowINV_MNU: 'ShowINV_MNU',
  ReprocessTransactions: 'ReprocessTransactions',
  INV_AppEnabled: 'INV_AppEnabled',
};

export const VerificationSelectionFieldEnum = {
  Approved: 'Approved',
  ApprovedAsOf: 'ApprovedAsOf',
  ApprovedAdjusted: 'ApprovedAdjusted',

  ToBeVerified: 'ToBeVerified',
  ToBeVerifiedAsOf: 'ToBeVerifiedAsOf',
  ToBeVerifiedAdjusted: 'ToBeVerifiedAdjusted',

  ShowApprovedCategoricalRow: 'ShowApprovedCategoricalRow',
  ApprovedCategorical: 'ApprovedCategorical',
  ApprovedCategoricalAsOf: 'ApprovedCategoricalAsOf',
  ApprovedCategoricalAdjusted: 'ApprovedCategoricalAdjusted',

  MaxToBeVerifiedCategoricalAdjusted: 'MaxToBeVerifiedCategoricalAdjusted',
  ShowToBeVerifiedCategoricalRow: 'ShowToBeVerifiedCategoricalRow',
  ToBeVerifiedCategorical: 'ToBeVerifiedCategorical',
  ToBeVerifiedCategoricalAsOf: 'ToBeVerifiedCategoricalAsOf',
  ToBeVerifiedCategoricalAdjusted: 'ToBeVerifiedCategoricalAdjusted',
  Phase: 'Phase',

  SelectionTypeDescription: 'SelectionTypeDescription',
  EarlyText: 'EarlyText',

  AppPer: 'AppPer',
  ErrorProneLimit: 'ErrorProneLimit',
  ShowErrorProneLimit: 'ShowErrorProneLimit',
  CaseNumberPer: 'CaseNumberPer',
  AsOfDate: 'AsOfDate',
  AdjustedText: 'AdjustedText',
  ShowCaseNumberPer: 'ShowCaseNumberPer',
  UserMessage: 'UserMessage',
};

export const SchoolCalendarFieldEnum = {
  Description: 'Description',
  FirstDayDT: 'FirstDayDT',
  LastDayDT: 'LastDayDT',
  FiscalYear: 'FiscalYear',
  MbeEnabled: 'MbeEnabled',
  MbeComplete: 'MbeComplete',
  MealExpirationDT: 'MealExpirationDT',
  MbeOperationalDays: 'MbeOperationalDays',
  GracePeriodCalendarDays: 'GracePeriodCalendarDays',
  CepTransferOperationalDays: 'CepTransferOperationalDays',
  BeginDay: 'BeginDay',
  EndDay: 'EndDay',
  IsServing: 'IsServing',
  SchoolCalendarExceptions: 'SchoolCalendarExceptions',
  SchoolCalendarSiteMasters: 'SchoolCalendarSiteMasters',
  SiteMasterId: 'SiteMasterId',
  SiteDescription: 'SiteDescription',
  SiteGroup: 'SiteGroup',
  Assigned: 'Assigned',
  AssignedCalendar: 'AssignedCalendar',
};

export const CycleMenuFieldEnum = {
  Description: 'Description',
  NutritionStandard: 'NutritionStdDescription',
  NumberOfDaysInCycle: 'NumberOfDays',
  SiteId: 'SiteId',
  SiteGroupId: 'SiteGroupId',
  IsActive: 'IsActive',
  FiscalYear: 'FiscalYear',
  Servings: 'Servings',
  AnalysisDays: 'AnalysisDays',
  SharedSource: 'SharedSourceDescription',
};

export const CycleMenuDetailsFieldEnum = {
  Description: 'Description',
  NutritionStandardDescription: 'NutritionStdDescription',
  NutritionStandardId: 'NutritionStandardId',
  NumberOfDaysInCycle: 'NumberOfDays',
  FiscalYear: 'FiscalYear',
  Servings: 'Servings',
  AnalysisDays: 'AnalysisDays',
  IsReadOnly: 'IsReadOnly',
  SharedSourceId: 'SharedSourceId',
  Id: 'Id',
};

export const EditMenuFieldEnum = {
  MenuDaysMap: 'MenuDaysMap',
  RecipesById: 'RecipesById',
  ReimbMealsByDayMap: 'ReimbMealsByDayMap',
  UserModified: 'UserModified',
  NutritionStandardId: 'NutritionStdID',
};

export const CycleMenuRecipeFieldEnum = {
  CycleMenuId: 'CycleMenuId',
  RecipeId: 'RecipeId',
  DayNumber: 'DayNumber',
  QtyOfPortion: 'QtyOfPortion',
  DisplayOnCalendar: 'DisplayOnCalendar',
  Name: 'Name',
  IsParent: 'IsParent',
  Children: 'Children',
  ProjectedServings: 'ProjectedServings',
  RecipeCategoryId: 'RecipeCategoryId',
  OrderNum: 'OrderNum',
  RecipeMeasure: 'RecipeMeasure',
  RecipeInactive: 'RecipeInactive',
  Alacarte: 'Alacarte',
  ContributionsPerMeasure: 'ContributionsPerMeasure',
  ServingsPercentage: 'ServingsPercentage',
  ComponentType: 'ComponentType',

  // Custom UI Fields
  ShortId: 'ShortId',
};

export const ApplyCycleMenuFieldEnum = {
  CycleMenuId: 'CycleMenuId',
  StartDay: 'StartDay',
  StartDateTime: 'StartDateTime',
  EndDateTime: 'EndDateTime',
  SkipHoliday: 'SkipHoliday',
  SkipWeekends: 'SkipWeekends',
  SiteIds: 'SiteIds',

  NumberOfDaysInCycle: 'NumberOfDaysInCycle',

  PublishMenu: 'PublishMenu',
  PublishToWebsite: 'PublishToWebsite',
  PublishToOMD: 'PublishToOMD', // online menu design
  PublishToMobileMenus: 'PublishToMobileMenus',
  PublishToDigitalDisplays: 'PublishToDigitalDisplays',
  PublishToOnlineOrdering: 'PublishToOnlineOrdering',
  PublishToGoingGreen: 'PublishToGoingGreen',

  PublishToPOS: 'PublishToPOS',
  PublishToK12PaymentCenter: 'PublishToK12PaymentCenter',
};

export const UnApplyCycleMenuFieldEnum = {
  CycleMenuId: 'CycleMenuId',
  StartDateTime: 'StartDateTime',
  EndDateTime: 'EndDateTime',
  SiteIds: 'SiteIds',

  NumberOfDaysInCycle: 'NumberOfDaysInCycle',
  PublishMenu: 'PublishMenu',
};

export const ReimbursableMealFieldEnum = {
  Fruit: 'Fruit',
  FruitJuice: 'FruitJuice',
  DarkGreenVeg: 'DarkGreenVeg',
  RedOrangeVeg: 'RedOrangeVeg',
  LegumesVeg: 'LegumesVeg',
  StarchyVeg: 'StarchyVeg',
  OtherVeg: 'OtherVeg',
  AdditionalVeg: 'AdditionalVeg',
  TotalVeg: 'TotalVeg',
  VegJuice: 'VegJuice',
  WholeGrain: 'WholeGrain',
  EnrichedGrain: 'EnrichedGrain',
  TotalGrain: 'TotalGrain',
  GrainDessert: 'GrainDessert',
  MeatAlt: 'MeatAlt',
  Milk: 'Milk',
};

export const AppliedMenuFieldEnum = {
  CycleMenuId: 'CycleMenuId',
  ServingDT: 'ServingDT',
  Description: 'Description',
  SiteId: 'SiteId',
  SiteGroup: 'SiteGroup',
  NutritionStdId: 'NutritionStdId',
};

export const ViewTransactionHistoryFieldEnum = {
  Price: 'Price',
  EffectiveDT: 'EffectiveDT',
  ItemId: 'ItemId',
  Status: 'Status',
  Description: 'Description',
  Balance: 'Balance',
  Payments: 'Payments',
  CheckNumber: 'CheckNumber',
  Purchase: 'Purchase',
  UserName: 'UserName',
  VoidedDT: 'VoidedDT',
  VoidedTime: 'VoidedTime',
  NutritionCode: 'NutritionCode',
  ActualDT: 'ActualDT',
  TransactionId: 'TransactionId',
  VoidedUser: 'vuser',
  Quantity: 'Quantity',
};

export const StudentFieldEnum = {
  ActualDate: 'ActualDate',
  ActualTime: 'ActualTime',
  Address1: 'Address1',
  Address2: 'Address2',
  AlaCarteExpAmount: 'AlaCarteExpAmount',
  AlaCarteExpFrequency: 'AlaCarteExpFrequency',
  AlaCarteExpense: 'AlaCarteExpense',
  AuditF8: 'AuditF8',
  Balance: 'Balance',
  BillingAcc: 'BillingAcc',
  BirthDate: 'BirthDate',
  CBSChargedAmtAllowed: 'CBSChargedAmtAllowed',
  CBSChargedMealCntAllowed: 'CBSChargedMealCntAllowed',
  CaseNumber: 'CaseNumber',
  CaseTypeId: 'CaseTypeId',
  CategoricallyEligibleReason: 'CategoricallyEligibleReason',
  Charge: 'Charge',
  ChargeByStatusMode: 'ChargeByStatusMode',
  City: 'City',
  DeniedReason: 'DeniedReason',
  DirectCertified: 'DirectCertified',
  EMailId: 'EMailId',
  EffectiveDate: 'EffectiveDate',
  EmancipatedMinor: 'EmancipatedMinor',
  Ethnicity: 'Ethnicity',
  EthnicityId: 'EthnicityId',
  ExportedToLPP: 'ExportedToLPP',
  ExtendedBenefits: 'ExtendedBenefits',
  FamilyId: 'FamilyId',
  FamilyIdentifier: 'FamilyIdentifier',
  FirstName: 'FirstName',
  FosterChild: 'FosterChild',
  GradeId: 'GradeId',
  HHFirstName: 'HHFirstName',
  HHLastName: 'HHLastName',
  HMRCategory: 'HMRCategory',
  HeadStart: 'HeadStart',
  HistoryTrg: 'HistoryTrg',
  HomePhone: 'HomePhone',
  HomeRoom: 'HomeRoom',
  HouseholdId: 'HouseholdId',
  Id: 'Id',
  IdBigInt: 'IdBigInt',
  IdSeed: 'IdSeed',
  IsAppSelectedForVerification: 'IsAppSelectedForVerification',
  IsGeneric: 'IsGeneric',
  IsLastStudentOnApp: 'IsLastStudentOnApp',
  KinGAP: 'KinGAP',
  LanguageId: 'LanguageId',
  LastModifiedBy: 'LastModifiedBy',
  LastName: 'LastName',
  LetterHistory: 'LetterHistory',
  Message: 'Message',
  MiddleName: 'MiddleName',
  NonLea: 'NonLea',
  ParticipationLPP: 'ParticipationLPP',
  Phone: 'Phone',
  RaceId: 'RaceId',
  RowVersion: 'RowVersion',
  SSN: 'SSN',
  SSN_HashBytes: 'SSN_HashBytes',
  SecondReview: 'SecondReview',
  ServingNum: 'ServingNum',
  Sex: 'Sex',
  SiteId: 'SiteId',
  SiteMaster: 'SiteMaster',
  State: 'State',
  StateNum: 'StateNum',
  StatusChangeDT: 'StatusChangeDT',
  StatusCurrent: 'StatusCurrent',
  StatusFuture: 'StatusFuture',
  StatusPrevious: 'StatusPrevious',
  Teacher: 'Teacher',
  TempApplication: 'TempApplication',
  TotalPay: 'TotalPay',
  TotalPurchase: 'TotalPurchase',
  WorkPhone: 'WorkPhone',
  ZipCode: 'ZipCode',
};

export const ApplicationFieldEnum = {
  //ApplicationInfo
  ActiveStatus: 'ActiveStatus',
  ApplicationInformation: 'ApplicationInformation',
  ApplicationDate: 'ApplicationDate',
  ApplicationName: 'ApplicationName',
  FamilyNumber: 'FamilyNumber',
  FamilySize: 'FamilySize',
  IsActive: 'IsActive',
  IsDeclinedBenefits: 'IsDeclinedBenefits',
  IsIncomplete: 'IsIncomplete',
  IsNewToApp: 'IsNewToApp',
  IsReducedBenefits: 'IsReducedBenefits',
  LanguageId: 'LanguageId',
  Notes: 'Notes',
  ReleaseMapping: 'ReleaseMapping',
  TotalAnnualIncome: 'TotalAnnualIncome',
  VerificationStatus: 'VerificationStatus',
  DeniedReason: 'DeniedReason',
  Students: 'Students',
  //HouseholdContactInfo
  HouseholdContactInfo: 'HouseholdContactInfo',
  Address1: 'Address1',
  Address2: 'Address2',
  City: 'City',
  EmailId: 'EmailId',
  HomePhone: 'HomePhone',
  State: 'State',
  WorkPhone: 'WorkPhone',
  ZipCode: 'ZipCode',
  //Member
  Members: 'Members',
  FirstName: 'FirstName',
  Id: 'Id',
  Income: 'Income',
  IsHOH: 'IsHOH',
  LastName: 'LastName',
  SSN: 'SSN',
  NoSSN: 'NoSSN',
  //Student
  BirthDate: 'BirthDate',
  EffectiveDate: 'EffectiveDate',
  EffectiveDateHasChanged: 'EffectiveDateHasChanged',
  Exceptions: 'Exceptions',
  GradeId: 'GradeId',
  HHFirstName: 'HHFirstName',
  HHLastName: 'HHLastName',
  IdSeed: 'IdSeed',
  RaceId: 'RaceId',
  EthnicityId: 'EthnicityId',
  MiddleName: 'MiddleName',
  ServingNumber: 'ServingNumber',
  SiteId: 'SiteId',
  StatusBeforeVerification: 'StatusBeforeVerification',
  StatusCurrent: 'StatusCurrent',
  StatusChangeType: 'StatusChangeType',
  StatusFuture: 'StatusFuture',
  Teacher: 'Teacher',
  //Income
  Freq1: 'Freq1',
  Freq2: 'Freq2',
  Freq3: 'Freq3',
  Freq4: 'Freq4',
  Income1: 'Income1',
  Income2: 'Income2',
  Income3: 'Income3',
  Income4: 'Income4',
  //Exceptions
  IsDirectCertified: 'IsDirectCertified',
  IsFoster: 'IsFoster',
  IsKinGap: 'IsKinGap',
  IsEmancipatedMinor: 'IsEmancipatedMinor',
  IsHeadStart: 'IsHeadStart',
  HMRCategory: 'HMRCategory',
  IsExtendedBenefits: 'IsExtendedBenefits',
  IsExtendedBenefitsHasChanged: 'IsExtendedBenefitsHasChanged',
  CaseNumber: 'CaseNumber',
  CaseTypeId: 'CaseTypeId',

  AdditionalInfo: 'AdditionalInfo',
  EmancipatedStudentId: 'EmancipatedStudentId',
  SecondReviewMarkAsNoChange: 'SecondReviewMarkAsNoChange',
  SecondReviewMarkAsIncomplete: 'SecondReviewMarkAsIncomplete',
  SecondReviewGrossIncomeCalculationError:
    'SecondReviewGrossIncomeCalculationError',
  SecondReviewCategoricalEligibilityError:
    'SecondReviewCategoricalEligibilityError',
  SecondReviewOtherError: 'SecondReviewOtherError',

  // Custom UI Fields
  IncomingHOHId: 'IncomingHOHId',
};

export const LanguageFieldEnum = {
  Id: 'Id',
  NotificationFree: 'NotificationFree',
  NotificationTempFree: 'NotificationTempFree',
  NotificationReduced: 'NotificationReduced',
  NotificationTempReduced: 'NotificationTempReduced',
  NotificationDeniedIncomplete: 'NotificationDeniedIncomplete',
  NotificationDeniedMoney: 'NotificationDeniedMoney',
  TemporaryFree: 'TemporaryFree',
  TemporaryReduced: 'TemporaryReduced',
  Status2Description: 'Status2Description',
  Status3Description: 'Status3Description',
  NotificationDeclinedBenefits: 'NotificationDeclinedBenefits',
  NotificationGracePeriod: 'NotificationGracePeriod',
};

export const ItemSummaryFieldEnum = {
  Site: 'Site',
  From: 'From',
  To: 'To',
  MealType: 'MealType',
};

export const DCImportFieldEnum = {
  ApplicationDate: 'ApplicationDate',
  ImportType: 'ImportType',
  UseCaseTypeMapping: 'UseCaseTypeMapping',
  DefaultCaseType: 'DefaultCaseTypeId',
  UseAddressInFile: 'UseAddressInFile',
  Delimiter: 'Delimiter',
  ContainsHeaderInformation: 'ContainsHeaderInformation',
  FileName: 'FileName',
  FileLength: 'FileLength',
  HeaderMapping: 'HeaderMapping',
  MatchOn: 'MatchOn',
  CreateFamilies: 'CreateFamilies',
  IgnoreStateNumberLeadingZeros: 'IgnoreStateNumberLeadingZeros',
};

export const ReimbursementRatesEnum = {
  Id: 'Id',
  Description: 'Description',
  FedBreakfastF: 'FedBreakfastF',
  FedLunchF: 'FedLunchF',
  PLS_SupperF: 'PLS_SupperF',
  FedBreakfastR: 'FedBreakfastR',
  FedLunchR: 'FedLunchR',
  PLS_SupperR: 'PLS_SupperR',
  FedBreakfastP: 'FedBreakfastP',
  FedLunchP: 'FedLunchP',
  PLS_SupperP: 'PLS_SupperP',
  FedSevereF: 'FedSevereF',
  FedSnackF: 'FedSnackF',
  FedMilkF: 'FedMilkF',
  FedSevereR: 'FedSevereR',
  FedSnackR: 'FedSnackR',
  FedSevereP: 'FedSevereP',
  FedSnackP: 'FedSnackP',
  FedMilkP: 'FedMilkP',
  StateBreakfastF: 'StateBreakfastF',
  StateLunchF: 'StateLunchF',
  StateBreakfastR: 'StateBreakfastR',
  StateLunchR: 'StateLunchR',
  StateBreakfastP: 'StateBreakfastP',
  StateLunchP: 'StateLunchP',
};

export const DemographicsReportFieldEnum = {
  AsOfDate: 'AsOfDate',
  ShowGradeDetailRows: 'ShowGradeDetailRows',
  SiteGroup: 'SiteGroup',
  Site: 'Site',
  Grade: 'Grade',
  ProvisionType: 'ProvisionType',
  GroupBySiteGroup: 'GroupBySiteGroup',
};

export const CaseTypeReportFieldEnum = {
  AsOfDate: 'AsOfDate',
  Site: 'Site',
  Grade: 'Grade',
  CaseType: 'CaseType',
  DCCat: 'DCCat',
  SortBy: 'SortBy',
  GroupBy: 'GroupBy',
  SummaryOnly: 'SummaryOnly',
};

export const ParticipationReportFieldEnum = {
  ReportType: 'ReportType',
  FeedingType: 'FeedingType',
  FromDate: 'FromDate',
  ToDate: 'ToDate',
  SummaryOnly: 'SummaryOnly',
  IncludeSpecialMSR: 'IncludeSpecialMSR',
  ShowSiteAvg: 'ShowSiteAvg',
};

export const UnclosedDatesReportFieldEnum = {
  FromDate: 'FromDate',
  ToDate: 'ToDate',
};

export const ChecksSummaryReportFieldEnum = {
  ReportType: 'ReportType',
  SiteId: 'SiteId',
  FromDate: 'FromDate',
  ToDate: 'ToDate',
  SortBy: 'SortBy',
  IsSupper: 'IsSupper',
};

export const VerificationReportFieldEnum = {
  FiscalYear: 'FiscalYear',
  SiteCount: 'SiteCount',
  Report: 'Report',
  StateAgencyName: 'StateAgencyName',
  SFAIsPublic: 'SFA_IsPublic',
  SFACity: 'SFA_City',
  SFAZip: 'SFA_Zip',
  SchoolsNotRequired: 'CollectionReport3_1',
  SchoolsExempt: 'CollectionReport5_1',
  VerificationCompleted: 'VerificationCompleted',
  VerificationCompletedByNov15: 'VerificationCompletedByNov15',
};

export const ReimbursementReportFieldEnum = {
  ReimbursementType: 'ReimbursementType',
  FeedingType: 'FeedingType',
  ReimbursementRateId: 'ReimbursementRateId',
  FromDate: 'FromDate',
  ToDate: 'ToDate',
  SummaryOnly: 'SummaryOnly',
};

export const ReceiptsAndCollectionsReportFieldEnum = {
  FeedingType: 'FeedingType',
  FromDate: 'FromDate',
  ToDate: 'ToDate',
  SummaryOnly: 'SummaryOnly',
  PrintOriginalValues: 'PrintOriginalValues',
};

export const GenericExportFieldEnum = {
  ExportFileType: 'ExportFileType',
  MonthYearDT: 'MonthYearDT',
  PadValuesWithZero: 'PadValuesWithZero',
  SelectedSites: 'SelectedSites',
};

export const GenericExportSetupFieldEnum = {
  ExportFileType: 'ExportFileType',
  ConstantValues: 'ConstantValues',
  ConstantValue: 'ConstantValue',
  ExportMappingList: 'ExportMappingList',
  Description: 'Description',
  Id: 'Id',
};

export const RevenueSummaryReportFieldEnum = {
  ReimbursementRateId: 'ReimbursementRateId',
  FromDate: 'FromDate',
  ToDate: 'ToDate',
  IsSupper: 'IsSupper',
  ShowEachDay: 'ShowEachDay',
};

export const AccuclaimEditReportFieldEnum = {
  FeedingType: 'FeedingType',
  SummaryType: 'SummaryType',
  FromDate: 'FromDate',
  ToDate: 'ToDate',
  PrintComments: 'PrintComments',
  OmitChanges: 'OmitChanges',
};
export const ChargesAndPrepaymentsReportFieldEnum = {
  FromDate: 'FromDate',
  ToDate: 'ToDate',
  Sites: 'Sites',
  User: 'User',
  Statuses: 'Statuses',
  AdjustmentsOnly: 'AdjustmentsOnly',
};

export const CEPFundsDueReportFieldEnum = {
  AmtDueBfst: 'AmtDueBfst',
  AmtDueLunch: 'AmtDueLunch',
  FromDate: 'FromDate',
  ToDate: 'ToDate',
  SummaryOnly: 'SummaryOnly',
};

export const UnappliedStudentsReportFieldEnum = {
  SortBy: 'SortBy',
  Grade: 'Grade',
  ProvisionType: 'ProvisionType',
  ShowFree: 'ShowFree',
  ShowReduced: 'ShowReduced',
  ShowPaid: 'ShowPaid',
  ShowDirectCertifiedOnly: 'ShowDirectCertifiedOnly',
  HadApplicationFromPriorYear: 'HadApplicationFromPriorYear',
};

export const LetterHistoryReportFieldEnum = {
  FormMode: 'FormMode',
  SiteId: 'SiteId',
  FromDate: 'FromDate',
  ToDate: 'ToDate',
  LetterTemplateIds: 'LetterTemplateIds',
  StudentIdSeeds: 'StudentIdSeeds',
  LetterTypes: 'LetterTypes',
  FamilyNumber: 'FamilyNumber',
  SortBy: 'SortBy',
  Statuses: 'Statuses',
};

export const VerificationResultsLettersFieldEnum = {
  LetterDate: 'LetterDate',
  HearingDate: 'HearingDate',
  MaxNumberOfLettersToPrint: 'MaxNumberOfLettersToPrint',
  ShowSiteName: 'ShowSiteName',
  StaffPersonName: 'StaffPersonName',
  StaffPersonPhone: 'StaffPersonPhone',
  NoResultsValue: 'NoResultsValue',
  UnprintedValue: 'UnprintedValue',
  PrintedValue: 'PrintedValue',
  PrintType: 'PrintType',
  UseStudentAddress: 'UseStudentAddress',
};

export const SelectionLettersFieldEnum = {
  LetterDate: 'LetterDate',
  ShowSiteName: 'ShowSiteName',
  ReceivedDate: 'ReceivedDate',
  CompletedDate: 'CompletedDate',
  StaffName: 'StaffName',
  StaffPhone: 'StaffPhone',
  PrintUnprinted: 'PrintUnprinted',
  PrintedCount: 'PrintedCount',
  UnprintedCount: 'UnprintedCount',
  UseStudentAddress: 'UseStudentAddress',
};

export const StatusChangeReportFieldEnum = {
  FilterAdded: 'FilterAdded',
  FilterChanged: 'FilterChanged',
  FilterWithdrawn: 'FilterWithdrawn',
  PrintSSN: 'PrintSSN',
  FromDate: 'FromDate',
  ToDate: 'ToDate',
  SortBy: 'SortBy',
  ProvisionType: 'ProvisionType',
  AsOfDate: 'AsOfDate',
};

export const InventoryBasicSetupFieldEnum = {
  Id: 'Id',
  ReferenceId: 'RefNum',
  Description: 'Description',
};
export const AssignItemsToSite = {
  CheckBox: 'CheckBox',
  ItemCode: 'ItemCode',
  ItemDescription: 'ItemDescription',
  VendorOrder: 'VendorOrder',
  VendorOnly: 'VendorOnly',
  ItemId: 'ItemId',
  ExclusiveOrderingSiteId: 'ExclusiveOrderingSiteId',
};

export const MonthlyClaimFormFieldEnum = {
  FromDate: 'FromDate',
};

export const MasterRosterFieldEnum = {
  SiteId: 'SiteId',
  SiteDescription: 'SiteDescription',
  ReportDT: 'ReportDT',
  UseAppDate: 'UseAppDate',
  SortBy: 'SortBy',
  ProvisionType: 'ProvisionType',
  FilterOnly: 'FilterOnly',
  StatusFilterMethod: 'StatusFilterMethod',
  Statuses: 'Statuses',
  StatusAll: 'StatusAll',
  StatusFree: 'StatusFree',
  StatusReduced: 'StatusReduced',
  StatusDenied: 'StatusDenied',
  GradeId: 'GradeId',
  GradeDescription: 'GradeDescription',
  ReleaseCategory: 'ReleaseCategory',
  ReleaseCategoryDescription: 'ReleaseCategoryDescription',
  ShowSSN: 'HideSSN',
};

export const MBENotificationLettersFieldEnum = {
  LetterDate: 'LetterDate',
  LetterType: 'LetterType',
  PrintType: 'PrintType',
  ShowSiteName: 'ShowSiteName',
  AddressFromType: 'AddressFromType',
  SortByType: 'SortByType',
};

export const EditServedItemFieldEnum = {
  ItemIdLetter: 'ItemIdLetter',
  ItemId: 'ItemId',
  Description: 'Description',
  Color: 'Color',
  ShortDescription: 'ShortDescription',
  NutritionCode: 'NutritionCode',
  Alternate: 'AlternateId',
  ItemCategory: 'POS_ItemCategoryId',
  ConvertAmounts: 'ConvertAmounts',
  Prices: 'Prices',
  IsAlternateItem: 'IsAlternateItem',
  IsOVSMeal: 'IsOVSMeal',
  ServingCost: 'ServingCost',
};

export const ItemColorFieldEnum = {
  Id: 'Id',
  Code: 'Code',
  Description: 'Description',
  Color: 'Color',
};

export const ServedItemAccessFieldEnum = {
  SiteIds: 'SiteIds',
  ItemIds: 'ItemIds',
};

export const NotificationAndDirectCertifiedLettersFieldEnum = {
  LetterType: 'LetterType',
  IsPrinted: 'IsPrinted',
  IsUnprinted: 'IsUnprinted',
  DateOfLetter: 'DateOfLetter',
  MaxNumberOfLettersToPrint: 'MaxNumberOfLettersToPrint',
  Selectby: 'SelectBy',
  FromDate: 'FromDate',
  ToDate: 'ToDate',
  AllDates: 'AllDates',
  Studentnumber: 'StudentNumber',
  ShowAdverseChangeOnly: 'ShowAdverseChangeOnly',
  ProvisionType: 'ProvisionType',
  SortBy: 'SortBy',
  ShowSiteName: 'ShowSiteName',
  Status: 'Status',
  IsEmail: 'IsEmail',
  EmailSource: 'EmailSource',
  UseStudentAddress: 'UseStudentAddress',
};

export const UserProfileFieldEnum = {
  UserId: 'UserId',
  Username: 'Username',
  FirstName: 'FirstName',
  LastName: 'LastName',
  RoleDescription: 'RoleDescription',
  Email: 'Email',
  OldPassword: 'OldPassword',
  NewPassword: 'NewPassword',
  ConfirmPassword: 'ConfirmPassword',
};

export const UncloseDayEnum = {
  Site: 'Site',
  FromDate: 'FromDate',
  ToDate: 'ToDate',
  FeedingType: 'FeedingType',
};

export const IdCardsFieldEnum = {
  UniqueIdentifier: 'UniqueIdentifier',
  SortBy: 'SortBy',
  Display: 'Display',
  FilterBy: 'FilterBy',
  SpecificStudents: 'SpecificStudents',
  Site: 'Site',
  Teacher: 'Teacher',
  Grade: 'Grade',
  DisplayBarcode: 'DisplayBarcode',
  DisplayPicture: 'DisplayPicture',
  DisplaySiteName: 'DisplaySiteName',
  DisplayUniqueIdentifier: 'DisplayUniqueIdentifier',
};

export const VendorFieldEnum = {
  Id: 'Id',
  VendorNum: 'VendorNum',
  FederalId: 'FederalId',
  Description: 'Description',
  POAddress1: 'POAddress1',
  POAddress2: 'POAddress2',
  POZip: 'POZip',
  POState: 'POState',
  POCity: 'POCity',
  POPhone: 'POPhone',
  POFax: 'POFax',
  POEmail: 'POEmail',
  IsPOAddSameAsRemittance: 'IsPOAddSameAsRemittance',
  RemitAddress1: 'RemitAddress1',
  RemitAddress2: 'RemitAddress2',
  RemitZip: 'RemitZip',
  RemitState: 'RemitState',
  RemitCity: 'RemitCity',
  RemitPhone: 'RemitPhone',
  Display: 'Display',
  IsWarehouseOrKitchen: 'IsWarehouseOrKitchen',
  IsDOD: 'IsDOD',
};

export const VendorEleFileConfigFieldEnum = {
  InvVFFHeaderInfoModel: 'InvVFFHeaderInfoModel',
  Id: 'Id',
  VendorId: 'VendorId',
  FileFormat: 'FileFormat',
  InvVFFFieldInfoModel: 'InvVFFFieldInfoModel',
  InvVFFDetailModel: 'InvVFFDetailModel',
  InvVFFCustomerInfoModel: 'InvVFFCustomerInfoModel',
  FieldInfoId: 'FieldInfoId',
  HeaderId: 'HeaderId',
  IdLength: 'IdLength',
  OrderId: 'OrderId',
  FieldValue: 'FieldValue',
  FileFields: 'FileFields',
  CustomerInfo: 'CustomerInfo',
  SiteId: 'SiteId',
  VendorsSiteId: 'VendorsSiteId',
  VendorsContractId: 'VendorsContractId',
};

export const TaxGroupSetupFieldEnum = {
  Id: 'Id',
  ReferenceId: 'RefNum',
  Description: 'Description',
  State: 'State',
  County: 'County',
  Local: 'Local',
};

export const ItemMaintenanceEnum = {
  IsWithCurrentBidPrice: 'IsWithCurrentBidPrice',
  BidGroups: 'BidGroups',
  ItemGroups: 'ItemGroups',
  Vendors: 'Vendors',
  GroupId_Location: 'GroupId_Location',
  PrepareInHouse: 'PrepareInHouse',
  AcceptableBrand1: 'AcceptableBrand1',
  AcceptableBrand2: 'AcceptableBrand2',
  AcceptableBrand3: 'AcceptableBrand3',
  AcceptableBrand4: 'AcceptableBrand4',
  AcceptableBrand5: 'AcceptableBrand5',
  ActiveStatus: 'ActiveStatus',
  AllowPartialOrdering: 'AllowPartialOrdering',
  CN_Code: 'CN_Code',
  Description: 'Description',
  Id: 'Id',
  Ingredient: 'Ingredient',
  ItemCode: 'ItemCode',
  ItemCodeDescription: 'ItemCodeDescription',
  ItemPackaging: 'ItemPackaging',
  PrimaryPrice: 'PrimaryPrice',
  Specification: 'Specification',
  GTINNumber: 'GTINNumber',
  VendorName: 'VendorName',
  ActiveStatusOptions: 'ActiveStatusOptions',
  StorageLocationIds: 'StorageLocationIds',
  MFRProductCode: 'MFRProductCode',
  MFRName: 'MFRName',
  MFRUrl: 'MFRUrl',
};

export const BidGroupEnum = {
  AllOnly: 0,
  UnassignedAndAll: 1,
  UnassignedOnly: 2,
  Nothing: 3,
};
export const CurrentBidPriceEnum = {
  All: 0,
  WithCurrentBidPrice: 1, //1 for dropdown value as true
  WithoutCurrentBidPrice: 2, //2 for dropdown value as false
};

export const OnHandEnum = {
  SiteId: 'SiteId',
  Description: 'Description',
  PrimaryQty: 'PrimaryQty',
  SecondaryQty: 'SecondaryQty',
  Value: 'Value',
};

export const BidPriceEnum = {
  BeginDT: 'BeginDT',
  ContractItem: 'ContractItem',
  CurrentBrand: 'CurrentBrand',
  EndDT: 'EndDT',
  HandlingFee: 'HandlingFee',
  Id: 'Id',
  ItemId: 'ItemId',
  PrimaryPrice: 'PrimaryPrice',
  QtyPerUnit: 'QtyPerUnit',
  SecondaryUnit: 'SecondaryUnit',
  SecondaryUnitMeasure: 'SecondaryUnitMeasure',
  SecondaryUnitWeight: 'SecondaryUnitWeight',
  SecondaryUnitWeightGrams: 'SecondaryUnitWeightGrams',
  ServingsPerUnit: 'ServingsPerUnit',
  UPC: 'UPC',
  Unit: 'Unit',
  VendorId: 'VendorId',
  VendorItem: 'VendorItem',
  VendorName: 'VendorName',
  CostPerServing: 'CostPerServing',
  UNASSIGNED: 'UNASSIGNED',
  BidItemDesc: 'BidItemDesc',
  Value: 'Value',
  GTINNumber: 'GTINNumber',
};

export const FifoEnum = {
  ItemCode: 'ItemCode',
  SiteId: 'SiteId',
  ReceiptDT: 'ReceiptDT',
  PrimaryQty: 'PrimaryQty',
  Unit: 'Unit',
  SecondaryQty: 'SecondaryQty',
  SecondaryUnit: 'SecondaryUnit',
  QtyPerUnit: 'QtyPerUnit',
  Price: 'Price',
  BeginDT: 'BeginDT',
  EndDT: 'EndDT',
  ShowAll: 'ShowAll',
  PrintOptions: 'PrintOptions',
  isGroupByItem: 'isGroupByItem',
  isGroupBySite: 'isGroupBySite',
  Value: 'Value',
  Description: 'Description',
  ItemId: 'ItemId',
  FromDate: 'FromDate',
  ToDate: 'ToDate',
  SelectAll: 'SelectAll',
};

export const TransactionDetailsEnum = {
  Cost: 'Cost',
  Item: 'Item',
  ItemDescription: 'ItemDescription',
  NetValueChange: 'NetValueChange',
  PrimaryPrice: 'PrimaryPrice',
  PrimaryQty: 'PrimaryQty',
  QtyPerUnit: 'QtyPerUnit',
  SecondaryPrice: 'SecondaryPrice',
  SecondaryQty: 'SecondaryQty',
  SecondaryUnit: 'SecondaryUnit',
  Site: 'Site',
  Transaction: 'Transaction',
  TransactionDT: 'TransactionDT',
  TransactionId: 'TransactionId',
  Unit: 'Unit',
  Vendor: 'Vendor',
  BeginDT: 'BeginDT',
  EndDT: 'EndDT',
  ShowFiscalYear: 'ShowFiscalYear',
  Adjustment: 'Adjustment',
  Order: 'Order',
  Physical: 'Physical',
  Receipt: 'Receipt',
  Transfer: 'Transfer',
  Usage: 'Usage',
  Value: 'Value',
};

export const GridPreferenceEnum = {
  id: 'id',
  accessor: 'accessor',
  show: 'show',
  visibility: 'visibility',
  locked: 'locked',
  Header: 'Header',
  filter: 'filter',
  sort: 'sort',
};

export const FilterEnum = {
  GroupId_Bid: 'GroupId_Bid',
  GroupId_Cat: 'GroupId_Cat',
  GroupId_Item: 'GroupId_Item',
  TaxGroupId: 'TaxGroupId',
  AlternateItemId: 'AlternateItemId',
  VendorId: 'VendorId',
  GroupId_Location: 'GroupId_Location',
  SiteId: 'SiteId',
  ReceiptVendorId: 'ReceiptVendorId',
  PrepareInHouse: 'PrepareInHouse',
};

export const TabItemMaintenanceEnum = {
  Details: 'Details',
  BidPrice: 'BidPrice',
  FIFO: 'FIFO',
  TransactionDetails: 'TransactionDetails',
};

export const ManageProcessOrderEnum = {
  BeginDT: 'BeginDT',
  EndDT: 'EndDT',
  SiteId: 'SiteId',
  OrderId: 'OrderId',
  SiteName: 'SiteName',
  OrderDate: 'OrderDate',
  DeliveryDate: 'DeliveryDate',
  Status: 'Status',
  Comments: 'Comments',
  ViewStatusOptions: 'ViewStatusOptions',
  All: 'All',
  Open: 'Open',
  Closed: 'Closed',
  PrintOptions: 'PrintOptions',
  Site: 'Site',
  Id: 'Id',
  ItemCode: 'ItemCode',
  Description: 'Description',
  Allowed: 'Allowed',
  OrderTypeDetails: 'OrderTypeDetails',
  OrderTypeName: 'OrderTypeName',
  OrderSiteDetails: 'OrderSiteDetails',
  BOPrintResult: 'BOPrintResult',
  POPrintResult: 'POPrintResult',
  WOPrintResult: 'WOPrintResult',
  KOPrintResult: 'KOPrintResult',
  ConsolidateOrders: 'ConsolidateOrders',
  ProcessId: 'ProcessId',
  Message: 'Message',
  DuplicateIds: 'DuplicateIds',
};

export const CreateEditOrderEnum = {
  ItemCode: 'ItemCode',
  ItemList: 'ItemList',
  Description: 'Description',
  ItemPackaging: 'ItemPackaging',
  PriQty: 'PriQty',
  Unit: 'Unit',
  SecQty: 'SecQty',
  PrimaryPrice: 'PrimaryPrice',
  TransactionDT: 'TransactionDT',
  SecondaryUnit: 'SecondaryUnit',
  VendorName: 'VendorName',
  OnHandDetail: 'OnHandDetail',
  OrderItemsInfo: 'OrderItemsInfo',
  SiteId: 'SiteId',
  Comments: 'Comments',
  ItemId: 'ItemId',
  ItemDescription: 'ItemDescription',
  QtyPerUnit: 'QtyPerUnit',
  PrimaryQty: 'PrimaryQty',
  SecondaryQty: 'SecondaryQty',
  Id: 'Id',
  DeliveryDate: 'DeliveryDate',
  OrderDate: 'OrderDate',
  Allowed: 'Allowed',
  OrderTypeDetails: 'OrderTypeDetails',
  TransactionDetail: 'TransactionDetail',
  Status: 'Status',
  Type: 'Type',
};

export const MealSummaryFieldEnum = {
  TypeOfSummary: 'TypeOfSummary',
  PrimarySiteId: 'PrimarySiteId',
  ClosingDate: 'ClosingDate',
  OpenAmount: 'OpenAmount',
  CloseAmount: 'CloseAmount',
  OpeningChecks: 'OpeningChecks',
  ClosingChecks: 'ClosingChecks',
  OpeningDenominations: 'OpeningDenominations',
  ClosingDenominations: 'ClosingDenominations',
  UserId: 'UserId',
  TransactionHistoryOnly: 'TransactionHistoryOnly',
};

export const DailyDepositFieldEnum = {
  Date: 'ServingDT',
  IsSupper: 'IsSupper',
  Site: 'PrimarySiteId',
  Deposit: 'DepositAmount',
  DailyDepositId: 'DailyDepositId',
  Misc1: 'Misc1Amount',
  Misc2: 'Misc2Amount',
  LaborHours: 'LabourHours',
  Comments: 'Comments',
  Sites: 'Details',
  IsClosed: 'IsClosed',
  Checks: 'Checks',
  C1: 'C1',
  C5: 'C5',
  C10: 'C10',
  C25: 'C25',
  C50: 'C50',
  D1: 'D1',
  D5: 'D5',
  D10: 'D10',
  D20: 'D20',
  D50: 'D50',
  D100: 'D100',
};

export const LettersFieldEnum = {
  LetterDate: 'LetterDate',
  LetterType: 'LetterType',
  Balance1: 'Balance1',
  Balance2: 'Balance2',
  MealStatuses: 'MealStatuses',
  ServingNum: 'ServingNum',
  SiteId: 'SiteId',
  GradeId: 'GradeId',
  PrintType: 'PrintType',
  SortByType: 'SortByType',
  Error: 'Error',
};

export const CEPSetupFieldEnum = {
  FiscalYear: 'FiscalYear',
  IdentifiedStudents: 'IdentifiedStudents',
  Site: 'Site',
  Sites: 'Sites',
  Multiplier: 'Multiplier',
};

export const CEPBulkProcessingFieldEnum = {
  ServingDate: 'ServingDate',
  MealType: 'MealType',
  ReimbursableItem: 'ReimbursableItem',
  TotalParticipation: 'TotalParticipation',
  FreeMeals: 'FreeMeals',
  PaidMeals: 'PaidMeals',
  Site: 'Site',
};

export const EditDailyDepositFieldEnum = {
  Tab: 'Tab',
  Sales: 'Sales',
  Accruals: 'Accruals',
  Info: 'DailyDepositInfo',
};

export const EditDailyDepositSalesFieldEnum = {
  TypeOfMeal: 'TypeOfMeal',
  StatusMerger: 'StatusMerger',
  Status: 'Status',
  BQty: 'BQty',
  BSales: 'BSales',
  LQty: 'LQty',
  LSales: 'LSales',
  OQty: 'OQty',
  OSales: 'OSales',
  SQty: 'SQty',
  SSales: 'SSales',
  BQtyDetail1: 'BQtyDetail1',
  BSalesDetail1: 'BSalesDetail1',
  LQtyDetail1: 'LQtyDetail1',
  LSalesDetail1: 'LSalesDetail1',
  BQtyDetail2: 'BQtyDetail2',
  BSalesDetail2: 'BSalesDetail2',
  LQtyDetail2: 'LQtyDetail2',
  LSalesDetail2: 'LSalesDetail2',
  OQtyDetail1: 'OQtyDetail1',
  OSalesDetail1: 'OSalesDetail1',
  OQtyDetail2: 'OQtyDetail2',
  OSalesDetail2: 'OSalesDetail2',
  SQtyDetail1: 'SQtyDetail1',
  SSalesDetail1: 'SSalesDetail1',
  SQtyDetail2: 'SQtyDetail2',
  SSalesDetail2: 'SSalesDetail2',
};

export const EditDailyDepositAccrualsFieldEnum = {
  TypeOfMeal: 'TypeOfMeal',
  StatusMerger: 'StatusMerger',
  Status: 'Status',
  PrepayAmount: 'PrepayAmount',
  PrepayUsed: 'PrepayUsed',
  ChargesMade: 'ChargesMade',
  ChargesPaid: 'ChargesPaid',
  ExtraCredit: 'ExtraCredit',
  Accruals: 'Accruals',
};

export const EditDailyDepositInfoFieldEnum = {
  Id: 'Id',
  DailyDepositId: 'DailyDepositId',
  SiteId: 'SiteId',
  AttendanceFactor: 'AttendanceFactor',
  ADAValue: 'ADAValue',
  ADMValue: 'ADMValue',
  MAXFree: 'MAXFree',
  MAXReduced: 'MAXReduced',
  MAXPaid: 'MAXPaid',
  AllowedFree: 'AllowedFree',
  AllowedReduced: 'AllowedReduced',
  AllowedPaid: 'AllowedPaid',
  SiteDeposit: 'SiteDeposit',
  PrimarySiteId: 'PrimarySiteId',
  ClosingDate: 'ClosingDate',
  Misc1Amount: 'Misc1Amount',
  Misc2Amount: 'Misc2Amount',
  DepositAmount: 'DepositAmount',
  LabourHours: 'LabourHours',
  ClosedStatus: 'ClosedStatus',
  CloserUserId: 'CloserUserId',
  Comments: 'Comments',
  IsSupper: 'IsSupper',
};

export const TransactionEnum = {
  PrimarySiteId: 'PrimarySiteId',
  ServerId: 'ServerId',
  MealType: 'MealType',
  StudentIdSeed: 'StudentIdSeed',
  TransactionType: 'TransactionType',
  WorkingDT: 'WorkingDT',
  AmountPaid: 'AmountPaid',
  CheckNumber: 'CheckNumber',
  BoughtItems: 'BoughtItems',
  UnitPrice: 'UnitPrice',
  AllowOverrideChargeLimits: 'AllowOverrideChargeLimits',
  Values: 'values',
};

export const StudentProfileEnum = {
  Id: 'Id',
  IdSeed: 'IdSeed',
  FirstName: 'FirstName',
  LastName: 'LastName',
  StatusCurrent: 'StatusCurrent',
  GradeId: 'GradeId',
  Teacher: 'Teacher',
  Allergens: 'Allergens',
  mastBal: 'mastBal',
  mastTotalPay: 'mastTotalPay',
  mastTotalPurchase: 'mastTotalPurchase',
  BillingAccSeed: 'BillingAccSeed',
  BillingAcc: 'BillingAcc',
  BillingAccSiteId: 'BillingAccSiteId',
  Balance: 'Balance',
  ServingNum: 'ServingNum',
  Charge: 'Charge',
  SchoolName: 'SchoolName',
  MinPPToDiscount: 'MinPPToDiscount',
  AdditionalCredit: 'AdditionalCredit',
  PrimarySiteId: 'PrimarySiteId',
  ChargeByStatusMode: 'ChargeByStatusMode',
  CBSChargedAmtAllowed: 'CBSChargedAmtAllowed',
  CBSChargedMealCntAllowed: 'CBSChargedMealCntAllowed',
  ChargedMealCount: 'ChargedMealCount',
  LanguageId: 'LanguageId',
  BirthDate: 'BirthDate',
  Bought: 'Bought',
  BoughtSpecialMilk: 'BoughtSpecialMilk',
  BoughtReimbSnack: 'BoughtReimbSnack',
  CanSpend: 'CanSpend',
  ProhibitedItems: 'ProhibitedItems',
};

export const OhioDailyWorksheetReportFieldEnum = {
  MealType: 'MealType',
  Date: 'Date',
  NonNeedyItemId: 'NonNeedyItemId',
  County: 'County',
  SiteIds: 'SiteIds',
};

export const OhioCashReceiptsReportFieldEnum = {
  MealType: 'MealType',
  Date: 'Date',
  County: 'County',
  SiteIds: 'SiteIds',
};
export const VirginiaClaimReportFieldEnum = {
  MonthYear: 'MonthYear',
  Sites: 'Sites',
  PrintOriginalValues: 'PrintOriginalValues',
};
export const PreviewProcessOrderEnum = {
  POWO: 'POWO',
  VendorName: 'VendorName',
  SiteId: 'SiteId',
  DeliveryDT: 'DeliveryDT',
  Cost: 'Cost',
  PrintOptions: 'PrintOptions',
  ItemCode: 'ItemCode',
  ItemDescription: 'ItemDescription',
  PreviewData: 'PreviewData',
  ExpiredBidsResult: 'ExpiredBidsResult',
  IsWarning: 'IsWarning',
  ReportSteamResult: 'ReportSteamResult',
};

export const ManagePurchaseOrderEnum = {
  All: 'All',
  Open: 'Open',
  Closed: 'Closed',
  BeginDT: 'BeginDT',
  EndDT: 'EndDT',
  ItemCode: 'ItemCode',
  Description: 'Description',
  ViewStatusOptions: 'ViewStatusOptions',
  Allowed: 'Allowed',
  Receipt: 'ReceiptId',
  OrderNumber: 'OrderNumber',
  Type: 'Type',
  PoWoNumber: 'POWONumber',
  SiteId: 'SiteId',
  SiteName: 'SiteName',
  Vendor: 'VendorId',
  OrderDT: 'OrderDate',
  DeliveryDT: 'Deliver_ReceiptDate',
  Status: 'Status',
  Invoice: 'Invoice',
  HandlingFeePO: 'HandlingFeePO',
  GlUpdated: 'GLUpdate',
  Comments: 'Comments',
  ViewReceiptOptions: 'ViewReceiptOptions',
  WithOrders: 'WithOrders',
  WithoutOrders: 'WithoutOrders',
  PrintOptions: 'PrintOptions',
  Order: 'OrderId',
  SortOptions: 'SortOptions',
  VendorName: 'VendorName',
  BOPrintResult: 'BOPrintResult',
  POPrintResult: 'POPrintResult',
  WOPrintResult: 'WOPrintResult',
  POWOComments: 'POWOComments',
  ReceiptComments: 'ReceiptComments',
  WOPOPrintResult: 'WOPOPrintResult',
  KOPrintResult: 'KOPrintResult',
  OrderTypeName: 'OrderTypeName',
};
export const CreateEditPurchaseOrderEnum = {
  SiteId: 'SiteId',
  VendorId: 'VendorId',
  Comments: 'Comments',
  DeliveryDT: 'DeliveryDT',
  PONum: 'PONum',
  OrderIds: 'OrderIds',
  BudgetCode: 'BudgetCode',
  EncumbranceCode: 'EncumbranceCode',
  ShippingCost: 'ShippingCost',
  ItemCode: 'ItemCode',
  ItemPackaging: 'ItemPackaging',
  Price: 'Price',
  PriQty: 'PriQty',
  Unit: 'Unit',
  SecQty: 'SecQty',
  SecondaryUnit: 'SecondaryUnit',
  TaxCost: 'TaxCost',
  MerchantCost: 'MerchantCost',
  OrderDT: 'OrderDate',
  POItemDetails: 'POItemDetails',
  VendorName: 'VendorName',
  PODate: 'PODate',
  SiteName: 'SiteName',
  TransactionId: 'TransactionId',
  Status: 'Status',
};
export const ItemEnum = {
  AllowPartialOrdering: 'AllowPartialOrdering',
  CountyTax: 'CountyTax',
  DiscountAmount: 'DiscountAmount',
  DiscountPct: 'DiscountPct',
  DisplayPrice: 'DisplayPrice',
  EncumbranceAccount: 'EncumbranceAccount',
  ExpenseAccount: 'ExpenseAccount',
  FederalTax: 'FederalTax',
  GrandTotal: 'GrandTotal',
  IsNonInventoryPOItem: 'IsNonInventoryPOItem',
  IsWarehouseOrder: 'IsWarehouseOrder',
  ItemCode: 'ItemCode',
  ItemDescription: 'ItemDescription',
  ItemId: 'ItemId',
  ItemPackaging: 'ItemPackaging',
  LocalTax: 'LocalTax',
  MDSE_AfterDiscount: 'MDSE_AfterDiscount',
  MerchandiseCost: 'MerchandiseCost',
  OrderPrice: 'OrderPrice',
  OrderQty: 'OrderQty',
  PrimaryPrice: 'PrimaryPrice',
  PrimaryQty: 'PrimaryQty',
  QtyPerUnit: 'QtyPerUnit',
  SecondaryQty: 'SecondaryQty',
  SecondaryUnit: 'SecondaryUnit',
  ShippingCost: 'ShippingCost',
  SiteId: 'SiteId',
  WarehouseSiteId: 'WarehouseSiteId',
  StateTax: 'StateTax',
  TaxCost: 'TaxCost',
  TransactionDetailId: 'TransactionDetailId',
  TransactionId: 'TransactionId',
  Unit: 'Unit',
  VendorItem: 'VendorItem',
  PriQty: 'PriQty',
  SecQty: 'SecQty',
  Description: 'Description',
  GTINNumber: 'GTINNumber',
  AlternateItemId: 'AlternateItem',
  AccountCategory: 'AccountCategory',
  BidGroup: 'BidGroup',
  ItemGroup: 'ItemGroup',
  TaxGroup: 'TaxGroup',
  ContractItem: 'ContractItem',
  UPC: 'UPC',
  BidPrice: 'BidPrice',
  BeginDate: 'BeginDate',
  EndDate: 'EndDate',
  ServingsPerPrimaryUnit: 'ServingsPerPrimaryUnit',
  MenuCosting: 'MenuCosting',
  OrderPreference: 'OrderPreference',
  StorageLocation: 'StorageLocation',
  MinimumParLevel: 'MinimumParLevel',
  MaximumParLevel: 'MaximumParLevel',
  TruckRoute: 'TruckRoute',
  ItemStatus: 'ItemStatus',
  QtyOrdered: 'QtyOrdered',
  QtyAvailable: 'QtyAvailable',
  QtyNeeded: 'QtyNeeded',
  VendorName: 'VendorName',
  QtyOnHand: 'QtyOnHand',
  Id: 'Id',
  VendorAllowed: 'VendorAllowed',
  VendorOnly: 'VendorOnly',
  ExclusiveOrderingSite: 'ExclusiveOrderingSite',
  CheckBox: 'CheckBox',
  PriQtyUsed: 'PriQtyUsed',
  SecQtyUsed: 'SecQtyUsed',
  PkgDescription: 'PkgDescription',
  QtyOnHand_Detail: 'QtyOnHand_Detail',
  PriQtyAdj: 'PriQtyAdj',
  SecQtyAdj: 'SecQtyAdj',
  Price: 'Price',
  NetValueChange: 'NetValueChange',
  OnHand: 'OnHand',
  CurrentBrand: 'CurrentBrand',
  OnHandDetail: 'OnHandDetail',
  ActiveStatus: 'ActiveStatus',
  ServingsPerPurchasingUnit: 'ServingsPerPurchasingUnit',
  AllowPartialOrderingSite: 'AllowPartialOrderingSite',
  StorageLocationIds: 'StorageLocationIds',
  PrepareInHouse: 'PrepareInHouse',
  HasBracketPricing: 'HasBracketPricing',
};

export const CreateEditTransferEnum = {
  FromSite: 'FromSite',
  ToSite: 'ToSite',
  TransferDT: 'TransactionDT',
  Comments: 'Comments',
  TransferID: 'TransferID',
  TransferItemsInfo: 'TransferItemsInfo',
  ItemCode: 'ItemCode',
  Description: 'Description',
  PriQty: 'PriQty',
  Unit: 'Unit',
  SecQty: 'SecQty',
  SecondaryUnit: 'SecondaryUnit',
  OnHandQty: 'OnHandQty',
  ItemId: 'ItemId',
  Packaging: 'Packaging',
  QtyPerUnit: 'QtyPerUnit',
  OnHand: 'OnHand',
  FromSiteName: 'FromSiteName',
  ToSiteName: 'ToSiteName',
};

export const TransferOrderEnum = {
  Allowed: 'Allowed',
  TransferID: 'TransferID',
  FromSite: 'FromSite',
  FromSiteName: 'FromSiteName',
  ToSite: 'ToSite',
  ToSiteName: 'ToSiteName',
  TransactionDT: 'TransactionDT',
  BeginDT: 'BeginDT',
  EndDT: 'EndDT',
  PrintOptions: 'PrintOptions',
  ItemCode: 'ItemCode',
  ItemDescription: 'ItemDescription',
  Site: 'Site',
};

export const CreateEditReceiptInventoryEnum = {
  ReceiptId: 'ReceiptId',
  ReceiptDt: 'ReceiptDt',
  POWONum: 'POWONum',
  OrderDT: 'OrderDT',
  OrderId: 'OrderId',
  Invoice: 'Invoice',
  Comments: 'Comments',
  ReceiptOrderItemsInfo: 'ReceiptOrderItemsInfo',
  WH: 'WH',
  IsWarehouseOrder: 'IsWarehouseOrder',
  PONumber: 'PONumber',
  WONumber: 'WONumber',
  ReceiptVendorId: 'ReceiptVendorId',
  VendorId: 'VendorId',
  VendorName: 'VendorName',
  POItemDetails: 'POItemDetails',
  SiteId: 'SiteId',
  SaveOption: 'SaveOption',
  WarehouseSiteId: 'WarehouseSiteId',
};

export const ReceiptSaveOptionEnum = {
  SaveOnly: 0,
  UpdateAndClose: 1,
  UpdateAndKeepOpen: 2,
};

export const RosterCurrentBalanceFieldEnum = {
  Site: 'Site',
  Sites: 'Sites',
  AllSitesChecked: 'AllSitesChecked',
  Teacher: 'Teacher',
  Grade: 'Grade',
  AccountBalanceType: 'AccountBalanceType',
  SortBy: 'SortBy',
  CustomBalanceFilter: 'CustomBalanceFilter',
  Statuses: 'Statuses',
  AllStatusesChecked: 'AllStatusesChecked',
  BalanceAmount: 'BalanceAmount',
  ShowBalance: 'ShowBalance',
  ShowStatus: 'ShowStatus',
  UseCustomBalanceFilter: 'UseCustomBalanceFilter',
  ExportType: 'ExportType',
  ShowParentContactInformation: 'ShowParentContactInformation',
};

export const UpdateCEPCountsFieldEnum = {
  Sites: 'Sites',
  FromDate: 'FromDate',
};

export const UpdateBidDetailsEnum = {
  BidDetailsInfo: 'BidDetailsInfo',
  AsOfDate: 'AsOfDate',
  ItemCode: 'ItemCode',
  Description: 'Description',
  ItemBidPriceEndDate: 'BidPriceEndDate',
  PrimaryPrice: 'PrimaryPrice',
  NewPrimaryPrice: 'NewPrimaryPrice',
  BidPriceBeginDate: 'BidPriceBeginDate',
  BidPriceEndDate: 'BidPriceEndDate',
  checked: 'checked',
  ItemId: 'ItemId',
};
export const ConsolidateEnum = {
  OrderDT: 'OrderDT',
  OrderIds: 'OrderIds',
  DeliveryDate: 'DeliveryDate',
  SiteId: 'SiteId',
  SiteName: 'SiteName',
  ItemSiteDetails: 'ItemSiteDetails',
  ConsolidateManagerModel: 'ConsolidateManagerModel',
  IsAssocationExists: 'IsAssocationExists',
  SiteIdDestinationName: 'SiteIdDestinationName',
  WHAssociation: 'WHAssociation',
  OrderConsolidatedVerificationModel: 'OrderConsolidatedVerificationModel',
  ConsolidatedOrderId: 'ConsolidatedOrderId',
  OriginalOrderId: 'OriginalOrderId',
  OrderConsolidatedVerification: 'OrderConsolidatedVerification',
};

export const UsageEnum = {
  Id: 'Id',
  Allowed: 'Allowed',
  UsageId: 'UsageId',
  SiteId: 'SiteId',
  SiteDescription: 'SiteDescription',
  UsageDT: 'DateUsage',
  BeginDT: 'BeginDT',
  EndDT: 'EndDT',
  PrintOptions: 'PrintOptions',
  ViewStatusOptions: 'ViewStatusOptions',
  Site: 'Site',
  Status: 'Status',
  Comments: 'Comments',
};

export const CreateEditUsageEnum = {
  ItemCode: 'ItemCode',
  Comments: 'Comments',
  UsageDT: 'DateUsage',
  SiteId: 'SiteId',
  Site: 'Site',
  PriQty: 'PriQty',
  SecQty: 'SecQty',
  UsageItemsInfo: 'UsageItemsInfo',
  UsageItems: 'UsageItems',
  ItemId: 'ItemId',
  Description: 'ItemDescription',
  Unit: 'Unit',
  SecondaryUnit: 'SecondaryUnit',
  QtyPerUnit: 'QtyPerUnit',
  PrimaryQty: 'PrimaryQty',
  SecondaryQty: 'SecondaryQty',
  PrimaryPrice: 'PrimaryPrice',
  OpType: 'OpType',
  PkgDescription: 'PkgDescription',
  QtyOnHand_Detail: 'QtyOnHand_Detail',
};

export const UpdateBidPriceDetailsEnum = {
  BidPriceEndDate: 'BidPriceEndDate',
  PrimaryPriceTextEnabled: 'PrimaryPriceTextEnabled',
  UnitComboEnabled: 'UnitComboEnabled',
  QtyPerUnitTextEnabled: 'QtyPerUnitTextEnabled',
  SecUnitComboEnabled: 'SecUnitComboEnabled',
  SecUnitMeasures: 'SecUnitMeasures',
  Units: 'Units',
  SecondaryUnits: 'SecondaryUnits',
  Vendors: 'Vendors',
  BidId: 'BidId',
  ItemId: 'ItemId',
  GTINNumber: 'GTINNumber',
  BracketType: 'BracketType',
  PerUnitValue: 'PerUnitValue',
  FromBracket: 'FromBracket',
  ToBracket: 'ToBracket',
  BracketPricingDetails: 'BracketPricingDetails',
  Price: 'Price',
};

export const PhysicalEnum = {
  SiteId: 'SiteId',
  SiteName: 'SiteName',
  StatusDesc: 'StatusDesc',
  Comments: 'Comments',
  FromDT: 'FromDT',
  EndDT: 'EndDT',
  Site: 'Site',
  ViewStatusOptions: 'ViewStatusOptions',
  PhysicalDT: 'PhysicalDate',
  Allowed: 'Allowed',
  SortOptions: 'SortOptions',
  GroupByOptions: 'GroupByOptions',
  All: 'All',
  Open: 'Open',
  Closed: 'Closed',
  Id: 'Id',
  Status: 'Status',
  EndQtyAsDecimal: 'EndQtyAsDecimal',
  NetValueChange: 'NetValueChange',
  Value: 'Value',
  PrintData: 'Data',
};

export const CreateEditPhysicalEnum = {
  Comments: 'Comments',
  PhysicalDT: 'PhysicalDate',
  SiteId: 'SiteId',
  Site: 'Site',
  PhysicalItemsInfo: 'PhysicalItemsInfo',
  PhysicalItems: 'PhysicalItems',
  Error: 'Error',
  SaveOption: 'SaveOption',
  PhysicalId: 'PhysicalId',
  StorageLocationIds: 'StorageLocationIds',
};

export const AdjustmentEnum = {
  AdjustmentItemsInfo: 'AdjustmentItemsInfo',
  AdjustmentItems: 'AdjustmentDetails',
  AdjustmentSummary: 'AdjustmentSummary',
  ReportResultString: 'ReportResultString',
  Allowed: 'Allowed',
  ItemCode: 'ItemCode',
  ItemDescription: 'ItemDescription',
  BeginDT: 'BeginDT',
  EndDT: 'EndDT',
  DateAdjust: 'DateAdjust',
  Site: 'Site',
  PrintOptions: 'PrintOptions',
  AdjustmentDT: 'AdjustmentDT',
  Comments: 'Comments',
  SiteId: 'SiteId',
  Id: 'Id',
  SiteName: 'SiteName',
  Status: 'StatusDesc',
  ItemId: 'ItemId',
  TransactionDT: 'TransactionDT',
  TransactionId: 'TransactionId',
  Error: 'Error',
};

export const AssignEntitiesEnum = {
  Site: 'Site',
  SiteGroup: 'SiteGroup',
  SortOptions: 'SortOptions',
  SiteGroupGrid: 'SiteGroupGrid',
  Checked: 'Checked',
  SiteGroupGridInfo: 'SiteGroupGridInfo',
  ItemGridInfo: 'ItemGridInfo',
  SiteGridInfo: 'SiteGridInfo',
  To: 'To',
  isAssignedToSite: 'isAssignedToSite',
  UserGridInfo: 'UserGridInfo',
  FoodItems: 'FoodItems',
  Users: 'Users',
};

export const SiteEnum = {
  Id: 'Id',
  IsSelected: 'IsSelected',
  Description: 'Description',
  OrderPreferenceId: 'OrderPreferenceId',
  OrderPreferenceName: 'OrderPreferenceName',
  MinimumParLevel: 'MinimumParLevel',
  MaximumParLevel: 'MaximumParLevel',
  CheckBox: 'CheckBox',
};

export const SiteGroupEnum = {
  SiteModel: 'SiteModel',
  Id: 'Id',
  Description: 'Description',
  MinimumParLevel: 'MinimumParLevel',
  MaximumParLevel: 'MaximumParLevel',
  CheckBox: 'CheckBox',
};

export const UserEnum = {
  UserName: 'UserName',
  FirstName: 'FirstName',
  LastName: 'LastName',
  CheckBox: 'CheckBox',
};

export const CustomQueryEnum = {
  QueryCategory: 'QueryCategory',
  QueryCategoryText: 'QueryCategoryText',
  Query: 'Query',
  Id: 'Id',
  Description: 'Description',
  CategoryName: 'CategoryName',
  Source: 'Source',
};

export const TransactionSummaryEnum = {
  Id: 'Id',
  BeginDT: 'BeginDT',
  EndDT: 'EndDT',
  FromDt: 'FromDt',
  ToDt: 'ToDt',
  SiteId: 'SiteId',
  Description: 'Description',
  Status: 'Status',
  LastDate: 'LastDate',
  ItemCode: 'ItemCode',
  ItemDescription: 'ItemDescription',
  PrintOptions: 'PrintOptions',
  TransactionSummaryGrid: 'TransactionSummaryGrid',
  ShowDetails: 'ShowDetails',
  WarningMessage: 'WarningMessage',
  Message: 'Message',
  Title: 'Title',
  OpenTranReportString: 'OpenTranReportString',
};

export const ImportExportItemsEnum = {
  Id: 'Id',
  Name: 'Name',
  Type: 'Type',
  ImportBidPrice: 'ImportBidPrice',
  BeginDT: 'BeginDT',
  EndDT: 'EndDT',
  FileFormat: 'FileFormat',
  Delimiter: 'Delimiter',
  IncludeHeaders: 'IncludeHeaders',
  FileName: 'FileName',
  LoadPrevious: 'LoadPrevious',
  FieldName: 'FieldName',
  ColumnNumber: 'ColumnNumber',
  ColName: 'ColName',
  ColLabel: 'ColLabel',
  ImportExportColumnModel: 'ImportExportColumnModel',
  SelectedFields: 'SelectedFields',
  Operation: 'Operation',
  IncludeWOCurrentBidPrice: 'IncludeWOCurrentBidPrice',
  IncludeBidPrice: 'IncludeBidPrice',
  ItemCode: 'ItemCode',
  Description: 'Description',
  GroupId_Cat: 'GroupId_Cat',
  PrimaryPrice: 'PrimaryPrice',
  Unit: 'Unit',
  QtyPerUnit: 'QtyPerUnit',
  SecondaryUnit: 'SecondaryUnit',
  VendorNum: 'VendorNum',
  VendorDescription: 'VendorDescription',
  ImportAllowed: 'ImportAllowed',
  ShowBidRelatedCol: 'ShowBidRelatedCol',
  ExportAllowed: 'ExportAllowed',
};

export const ItemStorageLocationEnum = {
  SiteId: 'SiteId',
  SiteDescription: 'SiteDescription',
  StorageLocation: 'StorageLocation',
  StoreId: 'StoreId',
  ItemStorageLocationInfo: 'ItemStorageLocationInfo',
};

export const UpdateOpenOrdersEnum = {
  SiteId: 'SiteId',
  SiteDescription: 'SiteDescription',
  OrderNumber: 'OrderNumber',
  WO: 'WO',
  TypeOptions: 'TypeOptions',
  DeliveryDT: 'DeliveryDT',
  SiteGroup: 'SiteGroup',
  WarehouseKitchen: 'WarehouseKitchen',
  AddItemList: 'AddItemList',
  RemoveItemList: 'RemoveItemList',
  Purchasing: 'Purchasing',
  Secondary: 'Secondary',
  Allowed: 'Allowed',
  AddQtyPrimary: 'AddQtyPrimary',
  AddQtySecondary: 'AddQtySecondary',
  RemoveQtyPrimary: 'RemoveQtyPrimary',
  RemoveQtySecondary: 'RemoveQtySecondary',
  RemoveItemListData: 'RemoveItemListData',
  AddItemListData: 'AddItemListData',
  UpdateOpenOrderCollection: 'UpdateOpenOrderCollection',
  WarehouseAvlbQuantity: 'WarehouseAvlbQuantity',
  Kitchen: 'Kitchen',
  SiteMasterTypeId: 'SiteMasterTypeId',
};

export const OpenOrderReportEnum = {
  Allowed: 'Allowed',
  Id: 'Id',
  Description: 'Description',
  EndDT: 'EndDT',
  FromDT: 'FromDT',
  GroupByOptions: 'GroupByOptions',
};
export const WarehouseReportEnum = {
  WarehouseKitchen: 'WarehouseKitchen',
  OnHoldTime: 'OnHoldTime',
  SortBy: 'SortBy',
  StorageLocation: 'StorageLocation',
  TruckRoute: 'TruckRoute',
  OrderingSite: 'OrderingSite',
  IncludeItemsForOpenOrder: 'IncludeItemsForOpenOrder',
  DateFrom: 'DateFrom',
  DateTo: 'DateTo',
  GroupBy: 'GroupBy',
  TruckRouteDescription: 'TruckRouteDescription',
  Type: 'Type',
};

export const ItemListingReportEnum = {
  Allowed: 'Allowed',
  ItemCode: 'ItemCode',
  Description: 'Description',
  SortOptions: 'SortOptions',
  BidPriceDate: 'BidPriceDate',
  Id: 'Id',
  ItemIdArray: 'ItemIdArray',
  ItemListInfo: 'ItemListInfo',
};

export const OrderFormReportEnum = {
  Allowed: 'Allowed',
  Id: 'Id',
  Description: 'Description',
  SortOptions: 'SortOptions',
};

export const PhysicalInventoryReportEnum = {
  Allowed: 'Allowed',
  Id: 'Id',
  Description: 'Description',
  SortOptions: 'SortOptions',
  FilterOptions: 'FilterOptions',
  GroupOptions: 'GroupOptions',
  CurrentOnHand: 'CurrentOnHand',
};

export const OnHandReportListingEnum = {
  Id: 'Id',
  ItemCode: 'ItemCode',
  Description: 'Description',
  Qty: 'Qty',
  Value: 'Value',
  PrintOptions: 'PrintOptions',
  ItemStatus: 'ItemStatus',
  BidGroup: 'BidGroup',
  ItemGroup: 'ItemGroup',
  AccountCategory: 'AccountCategory',
  VendorId: 'VendorId',
  SiteIds: 'SiteIds',
  ItemIds: 'ItemIds',
  ShowAllDates: 'ShowAllDates',
  IsSummaryReport: 'IsSummaryReport',
  SortBy: 'SortBy',
  LoadFIFORequestModel: 'LoadFIFORequestModel',
};

export const OnHandReportFifoEnum = {
  ItemIds: 'ItemIds',
  ShowAllDates: 'ShowAllDates',
  FromDt: 'FromDt',
  ToDt: 'ToDt',
  SiteIds: 'SiteIds',
  PrintOptions: 'PrintOptions',
};

export const OnHandReportTransactionDetailsEnum = {
  SiteId: 'SiteId',
  Site: 'Site',
  TransactionId: 'TransactionId',
  TransactionDT: 'TransactionDT',
  Transaction: 'Transaction',
  TransactionName: 'TransactionName',
  ItemIds: 'ItemIds',
  ShowAllDates: 'ShowAllDates',
  FromDt: 'FromDt',
  ToDt: 'ToDt',
  SiteIds: 'SiteIds',
  TransactionTypeOptions: 'TransactionTypeOptions',
  Types: 'Types',
  LoadFIFORequestModel: 'LoadFIFORequestModel',
};

export const TransactionHistoryReportEnum = {
  SiteIds: 'SiteIds',
  TypeId: 'TypeId',
  ItemId: 'ItemId',
  SortBy: 'SortBy',
  ItemStatus: 'ItemStatus',
  BidGroupId: 'BidGroupId',
  ItemGroupId: 'ItemGroupId',
  AccountCategoryId: 'AccountCategoryId',
  VendorId: 'VendorId',
  DateFrom: 'DateFrom',
  DateTo: 'DateTo',
  ItemSortOptions: 'ItemSortOptions',
  IsAllSitesSelected: 'IsAllSitesSelected',
};

export const RecipeVerified = {
  MealComponents: 'MealComponents',
  Allergens: 'Allergens',
  Attributes: 'Attributes',
};

export const RecipeFieldEnum = {
  Selected: 'Selected',
  Id: 'Id',
  Picture: 'Picture',
  Name: 'Name',
  Description: 'Description',
  ServingSize: 'ServingSize',
  MarketingDescription: 'MarketingDescription',
  QtyOfPortion: 'QtyOfPortion',
  RecipeCategoryId: 'RecipeCategoryId',
  GroupId: 'GroupId',
  SharedWith: 'SharedWith',
  Components: 'Components',
  Inactive: 'Inactive',
  RecipeSourceId: 'RecipeSourceId',
  CostPerServing: 'CostPerServing',
  ImportedRecipeCode: 'ImportedRecipeCode',
  MeasureOfPortion: 'MeasureOfPortion',
  NumberOfPortion: 'NumberOfPortion',
  HACCPId: 'HACCPId',
  AllergensVerified: 'AllergensVerified',
  ComponentType: 'ComponentType',
  UsedOnMenu: 'UsedOnMenu',
  DateModified: 'DateModified',
  DateCreated: 'DateCreated',
  ComponentSummary: 'ComponentSummary',
  Calories: 'Calories',
  SaturatedFat: 'SaturatedFat',
  Sodium: 'Sodium',
  ServingTemperatureId: 'ServingTemperatureId',
  ShareId: 'ShareId',
  PicturePreview: 'PicturePreview',
  UserModified: 'UserModified',
  Ingredients: 'Ingredients',
  IsFat: 'IsFat',
  CookingMethod: 'CookingMethod',
  MoistureChange: 'MoistureChange',
  FatChange: 'FatChange',
  TypeOfFat: 'TypeOfFat',
  TypeOfFatDescription: 'TypeOfFatDescription',
  PreparationInstructions: 'PreparationInstructions',
  ConvertedToIngredientId: 'ConvertedToIngredientId',
  ConvertedToIngredientCNCode: 'ConvertedToIngredientCNCode',
  ConvertedToIngredientDescription: 'ConvertedToIngredientDescription',
  CreatedFromIngredientId: 'CreatedFromIngredientId',
  ProductionNotes: 'ProductionNotes',
  PurchasingNotes: 'PurchasingNotes',
  ServingNotes: 'ServingNotes',
  MiscellaneousNotes: 'MiscellaneousNotes',
  LeftoverDays: 'LeftoverDays',
  ManufacturerName: 'ManufacturerName',
  ProductCode: 'ProductCode',

  // Meal Components
  WeightPerServing: 'WeightPerServing',
  MeatAlt: 'MeatAlt',
  Fruit: 'Fruit',
  FruitJuice: 'FruitJuice',
  GrainDessert: 'GrainDessert',
  EnrichedGrain: 'EnrichedGrain',
  WholeGrain: 'WholeGrain',
  TotalGrain: 'TotalGrain',
  LegumesVeg: 'LegumesVeg',
  OtherVeg: 'OtherVeg',
  AdditionalVeg: 'AdditionalVeg',
  DarkGreenVeg: 'DarkGreenVeg',
  RedOrangeVeg: 'RedOrangeVeg',
  StarchyVeg: 'StarchyVeg',
  TotalVeg: 'TotalVeg',
  VegJuice: 'VegJuice',
  Milk: 'Milk',
  Milk_LowFatFlavored: 'Milk_LowFatFlavored',
  Milk_LowFatUnflavored: 'Milk_LowFatUnflavored',
  Milk_ReducedUnflavored: 'Milk_ReducedUnflavored',
  Milk_ReducedFlavored: 'Milk_ReducedFlavored',
  Milk_WholeUnflavored: 'Milk_WholeUnflavored',
  Milk_WholeFlavored: 'Milk_WholeFlavored',
  Milk_SkimFlavored: 'Milk_SkimFlavored',
  Milk_SkimUnflavored: 'Milk_SkimUnflavored',

  // Nutrition
  TotalFat: 'TotalFat',
  Protein: 'Protein',
  TotalTrans: 'TotalTrans',
  Cholesterol: 'Cholesterol',
  CarboHydrate: 'CarboHydrate',
  DietaryFiber: 'DietaryFiber',
  Sugars: 'Sugars',
  AddedSugars: 'AddedSugars',
  VitaminD: 'VitaminD',
  Calcium: 'Calcium',
  Iron: 'Iron',
  Potassium: 'Potassium',
  VitaminAIU: 'VitaminAIU',
  VitaminC: 'VitaminC',
  Water: 'Water',
  Ash: 'Ash',
  Allergens: 'Allergens',
  AllAllergens: 'AllAllergens',
  AllAttributes: 'AllAttributes',
  NoAllergens: 'NoAllergens',
  AllergensNotAvailable: 'AllergensNotAvailable',
  Attributes: 'Attributes',
  Verified: 'Verified',

  LockBatch: 'LockBatch',
  Measures: 'Measures',
  TargetTemp: 'TargetTemp',
  HoldTemp: 'HoldTemp',
};

export const NutritionFactFieldEnum = {
  QtyOfPortion: 'QtyOfPortion',
  MeasureOfPortion: 'MeasureOfPortion',
  BaseWeight: 'BaseWeight',
  BaseWeightOGL: 'BaseWeightOGL',
};

export const NutrientsFieldEnum = {
  Calories: 'Calories',
  Sodium: 'Sodium',
  TotalFat: 'TotalFat',
  SaturatedFat: 'SaturatedFat',
  Protein: 'Protein',
  TotalTrans: 'TotalTrans',
  Cholesterol: 'Cholesterol',
  CarboHydrate: 'CarboHydrate',
  DietaryFiber: 'DietaryFiber',
  Sugars: 'Sugars',
  AddedSugars: 'AddedSugars',
  VitaminD: 'VitaminD',
  Calcium: 'Calcium',
  Iron: 'Iron',
  Potassium: 'Potassium',
  VitaminAIU: 'VitaminAIU',
  VitaminC: 'VitaminC',
  Water: 'Water',
  Ash: 'Ash',
  Iron_DRV: 'Iron_DRV',
  Calcium_DRV: 'Calcium_DRV',
  VitaminAIU_DRV: 'VitaminAIU_DRV',
  VitaminC_DRV: 'VitaminC_DRV',
  VitaminD_DRV: 'VitaminD_DRV',
  Potassium_DRV: 'Potassium_DRV',
};

export const RecipeIngredientMeasureFieldEnum = {
  Quantity1: 'Quantity1',
  Measure1: 'Measure1',
  Quantity2: 'Quantity2',
  Measure2: 'Measure2',
  IngredientId: 'IngredientId',
  IngredientName: 'IngredientName',
};

export const RecipeInstructionIngredientFieldEnum = {
  Id: 'Id',
  RecipeId: 'RecipeId',
  InstructionOrder: 'InstructionOrder',
  IngIndex: 'IngIndex',
  CN_Code: 'CN_Code',
  CN_SubCode: 'CN_SubCode',
  IngredientId: 'IngredientId',
};

export const MenuRecipeFieldEnum = {
  RecipeId: 'RecipeId',
  QtyOfPortion: 'QtyOfPortion',
  RecipeMeasure: 'RecipeMeasure',
  Name: 'Name',
};

export const DailyContributionsEnum = {
  DayNumber: 'DayNumber',
  Calories: 'Calories',
  DarkGreenVeg: 'DarkGreenVeg',
  EnrichedGrain: 'EnrichedGrain',
  Fruit: 'Fruit',
  FruitJuice: 'FruitJuice',
  GrainDessert: 'GrainDessert',
  LegumesVeg: 'LegumesVeg',
  MeatAlt: 'MeatAlt',
  Milk: 'Milk',
  Milk_2Varieties: 'Milk_2Varieties',
  OtherVeg: 'OtherVeg',
  AdditionalVeg: 'AdditionalVeg',
  RedOrangeVeg: 'RedOrangeVeg',
  SatFat: 'SatFat',
  Sodium: 'Sodium',
  StarchyVeg: 'StarchyVeg',
  TotalGrain: 'TotalGrain',
  TotalVeg: 'TotalVeg',
  VegJuice: 'VegJuice',
  WholeGrain: 'WholeGrain',
};
export const OrderPreferenceEnum = {
  Id: 'Id',
  Description: 'Description',
  OrderPreferenceId: 'OrderPreferenceId',
  OrderPreferences: 'OrderPreferences',
  Sites: 'Sites',
  WarehouseKitchen: 'WarehouseKitchen',
  StapleDetail: 'StapleDetail',
  StapleRoute: 'StapleRoute',
  StapleStorageLocationId: 'StapleStorageLocationId',
  StapleDayOfWeekId: 'StapleDayOfWeekId',
  WarehouseSiteId: 'WarehouseSiteId',
  Text: 'text',
  SiteType: 'SiteType',
};

export const ImportPicturesFieldEnum = {
  UseServingNumber: 'useServingNumber',
  File: 'File',
};

export const AppliedMenuListFormEnum = {
  StartDate: 'StartDate',
  EndDate: 'EndDate',
};

export const KitchenItemsEnum = {
  Id: 'Id',
  ItemCode: 'ItemCode',
  Description: 'Description',
  PrepareInHouse: 'PrepareInHouse',
  BidGroupId: 'BidGroupId',
  ItemGroupId: 'ItemGroupId',
};

export const KitchenPrepWorksheetEnum = {
  Select: 'Select',
  Id: 'Id',
  Kitchen: 'KitchenDescription',
  StatusDesc: 'StatusDesc',
  DeliveryDate: 'DeliveryDate',
  Status: 'Status',
  Comment: 'Comment',
  WarehouseKitchen: 'WarehouseKitchen',
  ViewStatusOptions: 'ViewStatusOptions',
  PrintOptions: 'PrintOptions',
  BeginDT: 'BeginDT',
  EndDT: 'EndDT',
  SiteMasterTypeId: 'SiteMasterTypeId',
};

export const IngredientFieldEnum = {
  Id: 'Id',
  Description: 'Description',
  Picture: 'Picture',
  Unit: 'Unit',
  Quantity1: 'Quantity1',
  Quantity2: 'Quantity2',
  Measure1: 'Measure1',
  Measure2: 'Measure2',
  CostPerServing: 'CostPerServing',
  CN_Code: 'CN_Code',
  DistributorCode: 'DistributorCode',
  IngredientName: 'IngredientName',
  PurchasedProductName: 'PurchasedProductName',
  Manufacturer: 'Manufacturer',
  ManufacturerProductCode: 'ManufacturerProductCode',
  SourceDesc: 'SourceDesc',
  Group: 'Group',
  ComponentSummary: 'ComponentSummary',
  HasPFS: 'HasPFS',
  UsedInRecipe: 'UsedInRecipe',
  UsedOnMenu: 'UsedOnMenu',
  DateCreated: 'DateCreated',
  DateModified: 'DateModified',
  Measures: 'Measures',
  Inactive: 'Inactive',
  INV_ItemId: 'INV_ItemId',
  Allergens: 'Allergens',
  AllAllergens: 'AllAllergens',
  Verified: 'Verified',
  RecipesWithIngredient: 'RecipesWithIngredient',
  CreatedFromRecipeId: 'CreatedFromRecipeId',
  IsOnMenu: 'IsOnMenu',
  AccountCategory: 'AccountCategory',
  Distributor: 'Distributor',
  AllergensVerified: 'AllergensVerified',
  Attributes: 'Attributes',
  CommodityRecipeCode: 'CommodityRecipeCode',
  IngIndex: 'IngIndex',
};

export const CloseSchoolYearFormEnum = {
  DoNotDeleteWithdrawnWithBalance: 'DoNotDeleteWithdrawnWithBalance',
  ShouldDeleteGrade: 'ShouldDeleteGrade',
  GradeIds: 'GradeIds',
};

export const MealEquivalentSetupEnum = {
  FiscalYear: 'FiscalYear',
  BreakfastToLunch: 'MealEqBtoL',
  SnackToLunch: 'MealEqRtoL',
  SupplementalToLunch: 'MealEqAtoL',
  SiteId: 'SiteId',
  SiteDescription: 'SiteDescription',
  SiteGroupDescription: 'SiteGroupDescription',
};

export const EditIngredientFieldEnum = {
  ProductName: 'ProductName',
  Description: 'Description',
  CNCode: 'CN_Code',
  ManufactName: 'ManufactName',
  SourceDesc: 'SourceDesc',
  GroupId: 'GroupId',
  DistributorCode: 'DistributorCode',
  ManufacturerProductCode: 'ManufacturerProductCode',
  Id: 'Id',
  ManufacturerURL: 'ManufacturerURL',
  SourceOfNutrientData: 'SourceOfNutrientData',
  MarketingDescription: 'MarketingDescription',
  UniversalProductCode: 'UniversalProductCode',
  UsedOnMenu: 'UsedOnMenu',
  MenuName: 'MenuName',
  Inactive: 'Inactive',
  Picture: 'Picture',
  PicturePreview: 'PicturePreview',
  MeasuresAndCost: 'MeasuresAndCost',
  CommodityRecipeCode: 'CommodityRecipeCode',
  ProductLabel: 'ProductLabel',
  PreparationInstructions: 'PreparationInstructions',
  StorageInstructions: 'StorageInstructions',
  ConvertedToRecipeId: 'ConvertedToRecipeId',
  CreatedFromRecipeId: 'CreatedFromRecipeId',
  CreatedFromRecipeDescription: 'CreatedFromRecipeDescription',
  // Meal components
  ComponentServingSize: 'ComponentServingSize',
  MeatAlt: 'MeatAlt',
  Fruit: 'Fruit',
  FruitJuice: 'FruitJuice',
  GrainDessert: 'GrainDessert',
  EnrichedGrain: 'EnrichedGrain',
  WholeGrain: 'WholeGrain',
  TotalGrain: 'TotalGrain',
  LegumesVeg: 'LegumesVeg',
  AdditionalVeg: 'AdditionalVeg',
  OtherVeg: 'OtherVeg',
  DarkGreenVeg: 'DarkGreenVeg',
  RedOrangeVeg: 'RedOrangeVeg',
  StarchyVeg: 'StarchyVeg',
  TotalVeg: 'TotalVeg',
  VegJuice: 'VegJuice',
  Milk: 'Milk',
  Milk_LowFatFlavored: 'Milk_LowFatFlavored',
  Milk_LowFatUnflavored: 'Milk_LowFatUnflavored',
  Milk_ReducedUnflavored: 'Milk_ReducedUnflavored',
  Milk_ReducedFlavored: 'Milk_ReducedFlavored',
  Milk_WholeUnflavored: 'Milk_WholeUnflavored',
  Milk_WholeFlavored: 'Milk_WholeFlavored',
  Milk_SkimFlavored: 'Milk_SkimFlavored',
  Milk_SkimUnflavored: 'Milk_SkimUnflavored',
  IsReadOnly: 'IsReadOnly',
};

export const IngMeasurementsFieldEnum = {
  CostPerServing: 'CostPerServing',
  CostPerGram: 'CostPerGram',

  Amount: 'Amount',
  Measurement: 'Measurement',
  Weight: 'Weight',
  BaseMeasure: 'BaseMeasure',
  Measures: 'Measures',
  IsDefault: 'IsDefault',

  UsedInRecipe: 'UsedInRecipe',
};

export const IngPurchasingFieldEnum = {
  INV_ItemId: 'INV_ItemId',
  InvItem: 'InvItem',
  PrimaryPrice: 'PrimaryPrice',
  Unit: 'Unit',
  QtyPerUnit: 'QtyPerUnit',
  SecondaryUnit: 'SecondaryUnit',
  SecondaryUnitWeight: 'SecondaryUnitWeight',
  SecondaryUnitMeasure: 'SecondaryUnitMeasure',
  AccountCategoryId: 'AccountCategoryId',
  VendorId: 'VendorId',
};

export const AttributeFieldEnum = {
  Attributes: 'Attributes',
  AllAttributes: 'AllAttributes',
  Verified: 'Verified',
};

export const CreateEditPrepWorksheetEnum = {
  DeliveryDT: 'DeliveryDate',
  Kitchen: 'Kitchen',
  Comments: 'Comments',
  ItemCode: 'ItemCode',
  Description: 'Description',
  OrderedPrimary: 'OrderedPrimary',
  OrderedSecondary: 'OrderedSecondary',
  NeededPrimary: 'NeededPrimary',
  NeededSecondary: 'NeededSecondary',
  PreparedPrimary: 'PreparedPrimary',
  PreparedSecondary: 'PreparedSecondary',
  Packaging: 'Packaging',
  OrderFulfilled: 'OrderFulfilled',
  KitchenPrepWorksheetInfo: 'KitchenPrepWorksheetInfo',
  KitchenDetails: 'KitchenDetails',
  KitchenItemListDetails: 'KitchenItemListDetails',
  KitchenId: 'KitchenId',
};

export const ManageTruckRoutesListEnum = {
  Id: 'Id',
  Description: 'Description',
  Type: 'Type',
};

export const ImportIngredientsFieldEnum = {
  FieldConfig: 'FieldConfig',
  ImportType: 'ImportType',
  ImportTypeId: 'ImportTypeId',
  Name: 'Name',
  Delimiter: 'Delimiter',
  IncludeHeaders: 'IncludeHeaders',
  File: 'file',
  SelectedFieldList: 'SelectedFieldList',
  FilePath: 'FilePath',
  ConfigName: 'ConfigName',
  LoadedConfigId: 'LoadedConfigId',
  CanBeUsedOnMenus: 'CanBeUsedOnMenus',
  UpdateKey: 'UpdateKey',

  // Column config properties
  ColumnName: 'ColumnName',
  ColumnLabel: 'ColumnLabel',
  ColumnNumber: 'ColumnNumber',
};

export const UserModifiedEnum = {
  UserModifiedSections: 'UserModifiedSections',
  Allergens: 'Allergens',
  Attributes: 'Attributes',
  MealComponents: 'MealComponents',
};

export const EligibilityByApplicationReportEnum = {
  ProvisionType: 'ProvisionType',
  AsOfDate: 'AsOfDate',
  IncludeApplicationSummary: 'IncludeApplicationSummary',
  Sites: 'Sites',
};

export const PreparationInstructionEnum = {
  Id: 'Id',
  Step: 'Step',
  DescriptionId: 'DescriptionId',
  Ingredients: 'Ingredients',
  Directions: 'Directions',
  HACCPInstructions: 'HACCPInstructions',
  Position: 'Position',
  TypeId: 'TypeId',
  HACCPCriticalLimitId: 'HACCPCriticalLimitId',
  HACCPNotes: 'HACCPNotes',
  Description: 'Description',
};

export const PreparationInstructionIngredientEnum = {
  Id: 'Id',
  Index: 'Index',
};

export const ControlInfoMenusFormEnum = {
  ApplyCycleBehavior_MNU: 'ApplyCycleBehavior_MNU',
  UpdateINV_MNU: 'UpdateINV_MNU',
  ShowINV_MNU: 'ShowINV_MNU',
};

export const ControlInfoHACCPFormEnum = {
  HACCP: 'HACCP',
};

export const ControlInfoHACCPTypeFormEnum = {
  HACCPType: 'HACCPType',
};

export const HACCPFieldEnum = {
  Description: 'Description',
  HACCPTypeId: 'HACCPTypeId',
  Id: 'Id',
};

export const HACCPTypeFieldEnum = {
  Description: 'Description',
  Id: 'Id',
};

export const ControlInfoRecipeGroupsFormEnum = {
  RecipeGroups: 'RecipeGroups',
};

export const RecipeGroupFieldEnum = {
  Id: 'Id',
  Category: 'Category',
  Description: 'Description',
};

export const EditProductionRecordFieldEnum = {
  ProductionRecords: 'ProductionRecords',
  CycleMenuId: 'CycleMenuId',
  StartDate: 'StartDate',
  EndDate: 'EndDate',
  SiteIds: 'SiteIds',
  ServeDate: 'ServeDate',
};

export const ProductionRecordFieldEnum = {
  Details: 'Details',
  Date: 'ServingDT',
  Status: 'Status',
  Id: 'Id',
  SiteId: 'SiteId',
  MealType: 'MealType',
  Standard: 'Standard',
  SubstitutionsMade: 'SubstitutionsMade',
  SubstitutionsMadeKnown: 'SubstitutionsMadeKnown',
  FeedingFigure: 'FeedingFigure',
  FeedingFigureAlacarte: 'FeedingFigureAlacarte',
  FeedingFigureAdult: 'FeedingFigureAdult',
  ServedStudents: 'ServedStudents',
  GradeFrom: 'GradeFrom',
  GradeTo: 'GradeTo',
  ServedCatered: 'ServedCatered',
  ServedSFSAdult: 'ServedSFSAdult',
  ServedOther: 'ServedOther',
  ServedSnacks: 'ServedSnacks',
  OfferVsServe: 'OfferVsServe',
  OfferVsServeNotes: 'OfferVsServeNotes',
  ServedNotes: 'ServedNotes',
  PersonnelHealthy: 'PersonnelHealthy',
  PersonnelCleanAppearance: 'PersonnelCleanAppearance',
  PersonnelWashingHands: 'PersonnelWashingHands',
  PersonnelNoBareHandContact: 'PersonnelNoBareHandContact',
  PersonnelThermometersChecked: 'PersonnelThermometersChecked',
  PersonnelNotes: 'PersonnelNotes',
  IsClosed: 'IsClosed',
  CloserUserId: 'CloserUserId',
  CycleMenuDescription: 'CycleMenuDescription',
  CycleMenuId: 'CycleMenuId',
  SC_Manager: 'SC_Manager',
  SC_Menu1Entree: 'SC_Menu1Entree',
  SC_Menu2Entree: 'SC_Menu2Entree',
  SC_Menu3Entree: 'SC_Menu3Entree',
  SC_OtherMenuItems: 'SC_OtherMenuItems',
  SC_ProgramType: 'SC_ProgramType',
  IsWaterAvailable: 'IsWaterAvailable',
  FeedingFigurePreK: 'FeedingFigurePreK',
  ServedPreK: 'ServedPreK',
  StateAttributes: 'StateAttributes',
  ServingDT: 'ServingDT',
  FeedingFigureOffered: 'FeedingFigureOffered',
};

export const ProductionRecordDetailFieldEnum = {
  Name: 'Description',
  RecipeCategoryId: 'RecipeCategoryId',
  QtyOfPortion: 'QtyOfPortion',
  MeasureOfPortion: 'MeasureOfPortion',
  ReimbursableMeals: 'ReimbursableMeals',
  PlannedAlacarte: 'PlannedAlacarte',
  PlannedAdult: 'PlannedAdult',
  Kitchen: 'Kitchen',
  x3History: 'x3History',
  Offered: 'Offered',
  OfferedAlacarte: 'OfferedAlacarte',
  OfferedAdult: 'OfferedAdult',
  Served: 'Served',
  ServedAlacarte: 'ServedAlacarte',
  ServedAdult: 'ServedAdult',
  Leftover: 'Leftover',
  AvailableReserve: 'AvailableReserve',
  TargetTemperature: 'TargetTemperature',
  HoldTemperature: 'HoldTemperature',
  TimeFirstPanPrepared: 'TimeFirstPanPrepared',
  PreparedTemperature: 'PreparedTemperature',
  RemovedTemperature: 'RemovedTemperature',
  LeftoverTemperature: 'LeftoverTemperature',
  Comments: 'Comments',
  IngredientId: 'IngredientId',
  RecipeId: 'RecipeId',
  IngredientAmount: 'IngredientAmount',
  Fruit: 'Fruit',
  DarkGreenVeg: 'DarkGreenVeg',
  RedOrangeVeg: 'RedOrangeVeg',
  LegumesVeg: 'LegumesVeg',
  StarchyVeg: 'StarchyVeg',
  OtherVeg: 'OtherVeg',
  Grain: 'Grain',
  MeatAlt: 'MeatAlt',
  Milk: 'Milk',
  Ingredients: 'Ingredients',
  IngredientQuantity1: 'IngredientQuantity1',
  IngredientQuantity2: 'IngredientQuantity2',
  IngredientMeasure1: 'IngredientMeasure1',
  IngredientMeasure2: 'IngredientMeasure2',
  IsSingleIngredientRecipe: 'IsSingleIngredientRecipe',
  IsLeftover: 'IsLeftover',
  Leftovers: 'Leftovers',
  Discard: 'Discard',
  LeftoverDays: 'LeftoverDays',
  RecipeNumberOfPortion: 'RecipeNumberOfPortion',
  RecipeQtyOfPortion: 'RecipeQtyOfPortion',
  Recipe: 'Recipe',
  UnitsFor100: 'UnitsFor100',
  ServingLine: 'ServingLine',
  OfferedPreK: 'OfferedPreK',
  ServedPreK: 'ServedPreK',
  PlannedPreK: 'PlannedPreK',

  // Custom UI Fields
  PlannedPercentage: 'PlannedPercentage',
  ReactKey: 'ReactKey',
  ArrayIndex: 'ArrayIndex',
};

export const ProductionRecipeLeftoverEnum = {
  Id: 'Id',
  SiteId: 'SiteId',
  RecipeLeftoverId: 'RecipeLeftoverId',
  Name: 'Name',
  Description: 'Description',
  ProductCode: 'ProductCode',
  ManufacturerName: 'ManufacturerName',
  Picture: 'Picture',
  ServingSize: 'ServingSize',
  QtyOfPortion: 'QtyOfPortion',
  MeasureOfPortion: 'MeasureOfPortion',
  RecipeCategoryId: 'RecipeCategoryId',
  RecipeSourceId: 'RecipeSourceId',
  GroupId: 'GroupId',
  NumberOfPortion: 'NumberOfPortion',
  MeatAlt: 'MeatAlt',
  Milk: 'Milk',
  DarkGreenVeg: 'DarkGreenVeg',
  Fruit: 'Fruit',
  LegumesVeg: 'LegumesVeg',
  OtherVeg: 'OtherVeg',
  RedOrangeVeg: 'RedOrangeVeg',
  StarchyVeg: 'StarchyVeg',
  EnrichedGrain: 'EnrichedGrain',
  WholeGrain: 'WholeGrain',
  Measures: 'Measures',
  Portions: 'Portions',
  UseByDT: 'UseByDT',
  Leftovers: 'Leftovers',
  StartDate: 'StartDate',
  EndDate: 'EndDate',
};

export const ProductionRecipeLeftoverDetailEnum = {
  RecipeId: 'RecipeId',
  RecipeLeftoverId: 'RecipeLeftoverId',
  SiteId: 'SiteId',
  Portions: 'Portions',
  UseByDT: 'UseByDT',
};

export const ControlInfoIngredientGroupsFormEnum = {
  IngredientGroups: 'IngredientGroups',
};

export const IngredientGroupFieldEnum = {
  Id: 'Id',
  Description: 'Description',
  LookupId: 'LookupId',
  IngredientSourceId: 'IngredientSourceId',
  Active: 'Active',
};

export const IngredientSourceFieldEnum = {
  Id: 'Id',
  ShortDesc: 'ShortDesc',
  Description: 'Description',
  ReadOnly: 'ReadOnly',
  SequenceBegin: 'SequenceBegin',
  SequenceEnd: 'SequenceEnd',
  Enabled: 'Enabled',
};

export const RecipePreparationReportEnum = {
  QtyOfPortion: 'QtyOfPortion',
  RecipeId: 'RecipeId',
  MeasureOfPortion: 'MeasureOfPortion',
  DefaultNumberOfPortion: 'DefaultNumberOfPortion',
  NumberOfPortion: 'NumberOfPortion',
  LockBatch: 'LockBatch',
  Batches: 'Batches',
};

export const AvailableKitchenPrepWorksheetEnum = {
  BeginDT: 'BeginDT',
  EndDT: 'EndDT',
  Kitchen: 'Kitchen',
  Expander: 'Expander',
  DeliveryDate: 'DeliveryDate',
  CreateBtn: 'CreateBtn',
  ItemCode: 'ItemCode',
  Description: 'Description',
  OrderedPrimary: 'OrderedPrimary',
  OrderedSecondary: 'OrderedSecondary',
  NeededPrimary: 'NeededPrimary',
  NeededSecondary: 'NeededSecondary',
  Packaging: 'Packaging',
  SiteMasterTypeId: 'SiteMasterTypeId',
};

export const CreateEditTruckRouteEnum = {
  Name: 'Name',
  SiteGroupId: 'SiteGroupId',
  BidGroupId: 'BidGroupId',
  ItemGroup: 'ItemGroup',
  VendorId: 'VendorId',
  StorageLocationId: 'StorageLocationId',
  AccountCategory: 'AccountCategory',
  ExistingRouteDescription: 'ExistingRouteDescription',
  IsAvailable: 'IsAvailable',
  RouteName: 'RouteName',
  ItemIds: 'ItemIds',
  SiteIds: 'SiteIds',
  Id: 'Id',
  GroupId_Bid: 'GroupId_Bid',
  GroupId_Cat: 'GroupId_Cat',
  GroupId_Item: 'GroupId_Item',
  Type: 'Type',
  AssignType: 'AssignType',
  Description: 'Description',
  IsSelected: 'IsSelected',
  VendorIds: 'VendorIds',
  DistributorIds: 'DistributorIds',
  AssignmentType: 'AssignmentType',
};

export const DiscrepancyReportEnum = {
  Site: 'Site',
  Vendor: 'Vendor',
  Type: 'Type',
  DateFrom: 'DateFrom',
  DateTo: 'DateTo',
  OnHandDateTo: 'OnHandDateTo',
};

export const PrintBarcodeEnum = {
  Allowed: 'Allowed',
  ItemCode: 'ItemCode',
  ItemId: 'ItemId',
  Description: 'Description',
  SortOptions: 'SortOptions',
  BidPriceDate: 'BidPriceDate',
  Id: 'Id',
  ItemIdArray: 'ItemIdArray',
  ItemListInfo: 'ItemListInfo',
  CurrentUpcItems: 'CurrentUpcItems',
};

export const UniversalDataExportEnum = {
  Id: 'Id',
  GroupId: 'GroupId',
  CategoryName: 'CategoryName',
  ColumnName: 'ColumnName',
  Groups: 'Groups',
  Fields: 'Fields',
  Configs: 'Configs',
  Description: 'Description',
  ExportType: 'ExportType',

  // export settings
  FieldConfig: 'FieldConfig',
  ConfigId: 'ConfigId',
  ImportType: 'ImportType',
  ImportTypeId: 'ImportTypeId',
  Name: 'Name',
  File: 'file',
  SelectedFieldIds: 'SelectedFieldIds',
  FilePath: 'FilePath',
  ConfigName: 'ConfigName',

  // filters
  SelectedSites: 'SelectedSites',
  Status: 'Status',
};

export const FamilyMatchUtilityFormEnum = {
  ConfidenceDropdown: 'ConfidenceDropdown',
};

export const Provision2FieldEnum = {
  SiteId: 'SiteId',
  ServingDate: 'ServingDate',
  MealType: 'MealType',
  ItemId: 'ItemId',
  ParticipationNumber: 'ParticipationNumber',
  Free: 'Free',
  Reduced: 'Reduced',
  Paid: 'Paid',
};

export const Provision2BaseRatesEnum = {
  FiscalYear: 'FiscalYear',
  OtherFiscalYear: 'OtherFiscalYear',
  ShowUseAnotherYearToggle: 'ShowUseAnotherYearToggle',
};

export const ManageTruckRouteScheduleListEnum = {
  Id: 'Id',
  Description: 'Description',
};

export const CreateEditTruckRouteScheduleEnum = {
  Id: 'Id',
  Description: 'Description',
  TruckRouteTimeComponent: 'TruckRouteTimeComponent',
  TruckRouteScheduleGrid: 'TruckRouteScheduleGrid',
  TimeSlot: 'TimeSlot',
  DayOfWeek: 'DayOfWeek',
  RouteIds: 'RouteIds',
  Type: 'Type',
};

export const TruckRouteReportEnum = {
  GroupByOptions: 'GroupByOptions',
  DayOfWeek: 'DayOfWeek',
};

export const ProductionGridFieldEnum = {
  CycleMenuDescription: 'CycleMenuDescription',
  StartDate: 'StartDate',
  EndDate: 'EndDate',
  SiteId: 'SiteId',
  SiteIds: 'SiteIds',
  Site: 'Site',
  CycleMenuId: 'CycleMenuId',
  Status: 'Status',
  ServingDT: 'ServingDT',
  MealType: 'MealType',
};

export const CloseProductionFieldEnum = {
  SignAndVerify: 'SignAndVerify',
};

export const ExportTotalsFieldEnum = {
  ExportType: 'ExportType',
  UnitNumber: 'UnitNumber',
  BreakfastItemId: 'BreakfastItemId',
  LunchItemId: 'LunchItemId',
  FromDate: 'FromDate',
  ToDate: 'ToDate',
  SelectedSiteIds: 'SelectedSiteIds',
  BreakfastItems: 'BreakfastItems',
  LunchItems: 'LunchItems',
};

export const SecondReviewDetailsEnum = {
  AllDates: 'AllDates',
  OnlyShowModified: 'OnlyShowModified',
  FromDate: 'FromDate',
  ToDate: 'ToDate',
  OrderBy: 'OrderBy',
};

export const ManageApplicationReprocessMealsEnum = {
  ToDate: 'ToDate',
  FromDate: 'FromDate',
  StudentIdSeeds: 'StudentIdSeeds',
};

export const FNS742AReportFieldEnum = {
  StateAgency: 'StateAgency',
  SFAId: 'SFAId',
  SFAName: 'SFAName',
};

export const RecipePreparationFiltersEnum = {
  Tab: 'Tab',
  Status: 'Status',
  GroupId: 'GroupId',
  SiteId: 'SiteId',
  CycleMenuId: 'CycleMenuId',
  Date: 'Date',
  MealTypeId: 'MealTypeId',
  OrderBy: 'OrderBy',
};

export const RecipePreparationTableFieldEnum = {
  Recipes: 'Recipes',
};

export const RecPrepRecipeFieldEnum = {
  RecipeId: 'RecipeId',
  Description: 'Description',
  Selected: 'Selected',
  Name: 'Name',
  NumberOfPortion: 'NumberOfPortion',
};

export const ViewApplicationDistributionFieldEnum = {
  TypeId: 'TypeId',
  FamilyId: 'FamilyId',
  HouseholdName: 'HouseholdName',
  HouseholdSSN: 'HouseholdSSN',
  Address1: 'Address1',
  Address2: 'Address2',
  City: 'City',
  State: 'State',
  ZipCode: 'ZipCode',
  HomePhone: 'HomePhone',
  WorkPhone: 'WorkPhone',
  ApplicationType: 'ApplicationType',
};

export const NYSirsExportFieldEnum = {
  TodayOrOtherDate: 'TodayOrOtherDate',
  BedsCode: 'BedsCode',
  AsOfDate: 'AsOfDate',
  IncludeEligibilityTypeCode: 'IncludeEligibilityTypeCode',
};

export const NYSirsAutoExportFieldEnum = {
  TimeOfDay: 'TimeOfDay',
  DayPicker: 'DayPicker',
  EnabledToggle: 'EnabledToggle',
  FileNameInput: 'FileNameInput',
  Hour: 'Hour',
  Minute: 'Minute',
  AmOrPm: 'AMorPM',
  FileName: 'FileName',
};

export const IPRangeFieldEnum = {
  Id: 'Id',
  Description: 'Description',
  LowerRange: 'LowerRange',
  UpperRange: 'UpperRange',
};

export const VendingMachineFieldEnum = {
  Id: 'Id',
  Name: 'Name',
  Description: 'Description',
  SiteId: 'SiteId',
  SiteDescription: 'SiteDescription',
  MachineId: 'MachineId',
};

export const MealsPerLaborHourFieldEnum = {
  From: 'From',
  To: 'To',
};

export const SCSLPFieldEnum = {
  MealType: 'MealType',
  Month: 'Month',
  Year: 'Year',
  CompletedBy: 'CompletedBy',
  Sites: 'Sites',
};

export const NCSFS4FieldEnum = {
  From: 'From',
  To: 'To',
  FiscalYearToDate: 'FiscalYearToDate',
  SummaryOnly: 'SummaryOnly',
  Sites: 'Sites',
};

export const PrintProductionRecordFieldEnum = {
  FromDate: 'FromDate',
  ToDate: 'ToDate',
  UsePlannedNumbers: 'UsePlannedNumbers',
  SiteId: 'SiteId',
  CycleMenuId: 'CycleMenuId',
};

export const ImportPreviewFieldEnum = {
  FileEncoding: 'FileEncoding',
  Delimiter: 'delimiter',
  ImportFile: 'import_file',
  RecordCount: 'recordcount',
};

export const SchoolSiteOrderFieldEnum = {
  StartServingDT: 'StartServingDT',
  EndServingDT: 'EndServingDT',
  IsDeliverOnServingDate: 'IsDeliverOnServingDate',
  DeliveryDT: 'DeliveryDT',
  DistributorId: 'DistributorId',
  SiteIds: 'SiteIds',
  SiteGroupIds: 'SiteGroupIds',
};

export const EditAppliedMenuConfigFieldEnum = {
  AnalysisDays: 'AnalysisDays',
  StartDate: 'StartDate',
  EndDate: 'EndDate',
};

export const GetAppliedMenuFieldEnum = {
  StartDate: 'StartDate',
  EndDate: 'EndDate',
  AnalysisDays: 'AnalysisDays',
  SiteId: 'SiteId',
  CycleMenuId: 'CycleMenuId',
};

export const WriteAppliedMenuFieldEnum = {
  StartDT: 'StartDT',
  EndDT: 'EndDT',
  SiteId: 'SiteId',
  CycleMenuId: 'CycleMenuId',
  Details: 'Details',
  ReimbMeals: 'ReimbMeals',
  NutritionStdId: 'NutritionStdId',
  MenuDescription: 'MenuDescription',
};

export const SalesAnalysisReportFieldEnum = {
  MealTypes: 'MealTypes',
  Statuses: 'Statuses',
  FromDate: 'FromDate',
  AllDates: 'AllDates',
  SiteId: 'SiteId',
  ToDate: 'ToDate',
  Grade: 'Grade',
  UserId: 'UserId',
};

export const ItemCostingFieldEnum = {
  FromDate: 'FromDate',
  ToDate: 'ToDate',
  Sites: 'Sites',
  IsSummary: 'IsSummary',
};

export const NutrientAnalysisFieldEnum = {
  SiteId: 'SiteId',
  Site: 'Site',
  FromDate: 'FromDate',
  ToDate: 'ToDate',
  MealType: 'MealType',
  NutritionStandard: 'NutritionStandard',
  CycleMenuId: 'CycleMenuId',
  Days: 'AnalysisDays',
  GetActiveAndInactive: 'GetActiveAndInactive',
};

export const IngredientListingFieldEnum = {
  IngredientIds: 'IngredientIds',
  BaseWeightType: 'BaseWeightType',
  SortBy: 'SortBy',
  All: 'All',
  SearchParam: 'SearchParam',
};

export const SimpleAverageFieldEnum = {
  Site: 'Site',
  FromDate: 'FromDate',
  ToDate: 'ToDate',
  MealType: 'MealType',
  CycleMenu: 'CycleMenu',
  ReimbursableItemsOnly: 'ReimbursableItemsOnly',
  IncludeAllergyReport: 'IncludeAllergyReport',
};

export const FoodBasedAnalysisFieldEnum = {
  Site: 'SiteId',
  FromDate: 'FromDate',
  ToDate: 'ToDate',
  NumDays: 'AnalysisDays',
  MealType: 'MealType',
  SortBy: 'SortByType',
  SortByComponent: 'SortByComponent',
  AnalysisType: 'AnalysisType',
  NutritionStandard: 'NutritionStandard',
  Menu: 'CycleMenuId',
};

export const DiscontinuedIngredientsFieldEnum = {
  IngredientIds: 'IngredientIds',
  PrintRecipe: 'PrintRecipe',
  CycleMenuId: 'CycleMenuId',
  ViewType: 'ViewType',
};

export const RecipeListingFieldEnum = {
  ReportType: 'ReportType',
  SortBy: 'SortBy',
  DoesNotContainAllergen: 'DoesNotContainAllergen',
  Allergens: 'Allergens',
  CNCode: 'CNCode',
  ShowInactive: 'ShowInactive',
  RecipeIds: 'RecipeIds',
};

export const GACashIncomeFieldEnum = {
  FromDate: 'FromDate',
  ToDate: 'ToDate',
  Sites: 'Sites',
};

export const DefaultLaborHoursFieldEnum = {
  Sites: 'Sites',
  FiscalYear: 'FiscalYear',
  DefaultLaborHours: 'DefaultLaborHours',
};

export const ScannedApplicationFieldEnum = {
  FormId: 'FormId',
  LanguageId: 'LanguageId',
  FamilySize: 'FamilySize',
  HouseholdFirstName: 'HouseholdFirstName',
  HouseholdLastName: 'HouseholdLastName',
  HouseholdAddress1: 'HouseholdAddress1',
  HouseholdAddress2: 'HouseholdAddress2',
  HouseholdPhone: 'HouseholdPhone',
  HouseholdWkPhone: 'HouseholdWkPhone',
  ReleaseCategory: 'ReleaseCategory',
  RaceId: 'RaceId',
  HouseholdIncome1: 'HouseholdIncome1',
  Freq1: 'Freq1',
  HouseholdIncome2: 'HouseholdIncome2',
  Freq2: 'Freq2',
  HouseholdIncome3: 'HouseholdIncome3',
  Freq3: 'Freq3',
  HouseholdIncome4: 'HouseholdIncome4',
  Freq4: 'Freq4',
  ActiveStatus: 'ActiveStatus',
  EmailId: 'EmailId',
  IsHispanic: 'IsHispanic',
  City: 'City',
  State: 'State',
  Zip: 'Zip',
  BatchDate: 'BatchDate',
  BatchTime: 'BatchTime',
  Members: 'Members',
  ApplicationDate: 'ApplicationDate',

  // Member Fields
  MemberFirstName: 'MemberFirstName',
  MemberLastName: 'MemberLastName',
  MemberStudentNumber: 'MemberStudentNumber',
  MemberCaseNumber: 'MemberCaseNumber',
  MemberSchoolNumber: 'MemberSchoolNumber',
  MemberGradeId: 'MemberGradeId',
  MemberTeacher: 'MemberTeacher',
  MemberIncome1: 'MemberIncome1',
  MemberIncome2: 'MemberIncome2',
  MemberIncome3: 'MemberIncome3',
  MemberIncome4: 'MemberIncome4',
  CaseTypeId: 'CaseTypeId',
  BirthDateDT: 'BirthDateDT',
  HMR: 'HMR',
  Foster: 'Foster',
  KinGap: 'KinGap',
};

export const TaxRateFieldEnum = {
  Id: 'Id',
  Name: 'Name',
  Free: 'Free',
  Reduced: 'Reduced',
  Paid: 'Paid',
  Teacher: 'Teacher',
  Adult: 'Adult',
  SchoolFoodService: 'SchoolFoodService',
  Catering: 'Catering',
};

export const AssignTaxRateSitesFieldEnum = {
  Sites: 'Sites',
};

export const ProductionReportSetupFields = {
  Id: 'Id',
  Description: 'Description',
  LastModifiedDate: 'LastModifiedDate',
  ReportName: 'ReportName',
  ReportVersion: 'ReportVersion',
  Settings: 'Settings',
  TemplateId: 'TemplateId',
};

export const NutritionStandardsReportFieldEnum = {
  NutritionStandard: 'NutritionStandard',
};

export const NotesReportFieldEnum ={
  ReportFormat: 'ReportFormat',
  SystemGeneratedOnly: 'SystemGeneratedOnly',
  SortBy: 'SortBy',
  Site: 'Site'
}



// WEBPACK FOOTER //
// ./src/common/FieldEnum.js